import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './form-builder.component.scss';
var FormBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(FormBuilder, _super);
    function FormBuilder(element) {
        return _super.call(this, element) || this;
    }
    FormBuilder.prototype.init = function () {
        this.buttonConverter = Array.from(this.element.querySelectorAll('.js-converter'));
        this.inputs = Array.from(this.element.querySelectorAll('input'));
        // generic form
        if (this.element.querySelector('.js-fields')) {
            this.containerFieldsComponents = this.element.querySelector('.js-fields');
        }
        if (this.element.querySelector('.js-generic-form-field')) {
            this.buttonFieldOpen = Array.from(this.element.querySelectorAll('.js-generic-form-field'));
        }
        if (this.element.querySelector('.form-builder__generic--heading')) {
            this.inputFormHeading = this.element.querySelector('.form-builder__generic--heading');
        }
        if (this.element.querySelector('.form-builder__generic--analytics')) {
            this.inputFormAnalytics = this.element.querySelector('.form-builder__generic--analytics');
        }
        if (this.element.querySelector('.form-builder__generic--recipient')) {
            this.inputFormRecipient = this.element.querySelector('.form-builder__generic--recipient');
        }
        if (this.element.querySelector('.form-builder__generic--email')) {
            this.inputFormEmail = this.element.querySelector('.form-builder__generic--email');
        }
        if (this.element.querySelector('.form-builder__generic--subject')) {
            this.inputFormSubject = this.element.querySelector('.form-builder__generic--subject');
        }
        if (this.element.querySelector('.form-builder__generic--button')) {
            this.inputFormButton = this.element.querySelector('.form-builder__generic--button');
        }
        if (this.element.querySelector('.js-generic-form-add-heading')) {
            this.buttonFieldAddHeading = this.element.querySelector('.js-generic-form-add-heading');
        }
        if (this.element.querySelector('.js-generic-form-add-paragraph')) {
            this.buttonFieldAddParagraph = this.element.querySelector('.js-generic-form-add-paragraph');
        }
        if (this.element.querySelector('.js-generic-form-add-input')) {
            this.buttonFieldAddInput = this.element.querySelector('.js-generic-form-add-input');
        }
        if (this.element.querySelector('.js-generic-form-add-number')) {
            this.buttonFieldAddInputNumber = this.element.querySelector('.js-generic-form-add-number');
        }
        if (this.element.querySelector('.js-generic-form-add-email')) {
            this.buttonFieldAddInputEmail = this.element.querySelector('.js-generic-form-add-email');
        }
        if (this.element.querySelector('.js-generic-form-add-textarea')) {
            this.buttonFieldAddTextarea = this.element.querySelector('.js-generic-form-add-textarea');
        }
        if (this.element.querySelector('.js-generic-form-add-date')) {
            this.buttonFieldAddDate = this.element.querySelector('.js-generic-form-add-date');
        }
        if (this.element.querySelector('.js-generic-form-add-dropdown')) {
            this.buttonFieldAddDropdown = this.element.querySelector('.js-generic-form-add-dropdown');
        }
        if (this.element.querySelector('.js-generic-form-add-icon-text')) {
            this.buttonFieldAddIconText = this.element.querySelector('.js-generic-form-add-icon-text');
        }
        if (this.element.querySelector('.js-generic-form-add-checkbox')) {
            this.buttonFieldAddCheckbox = this.element.querySelector('.js-generic-form-add-checkbox');
        }
        if (this.element.querySelector('.js-generic-form-add-checkbox')) {
            this.buttonFieldAddCheckbox = this.element.querySelector('.js-generic-form-add-checkbox');
        }
        if (this.element.querySelector('.js-generic-form-add-radio')) {
            this.buttonFieldAddRadioButton = this.element.querySelector('.js-generic-form-add-radio');
        }
        if (this.element.querySelector('.js-generic-form-add-id-passport')) {
            this.buttonFieldAddIdNumber = this.element.querySelector('.js-generic-form-add-id-passport');
        }
        if (this.element.querySelector('.js-generic-form-add-countries')) {
            this.buttonFieldAddCountries = this.element.querySelector('.js-generic-form-add-countries');
        }
        if (this.element.querySelector('.js-generic-form-add-provinces')) {
            this.buttonFieldAddProvince = this.element.querySelector('.js-generic-form-add-provinces');
        }
        if (this.element.querySelector('.js-generic-form-add-hidden')) {
            this.buttonFieldAddHidden = this.element.querySelector('.js-generic-form-add-hidden');
        }
        if (this.element.querySelector('.js-generic-form-preview')) {
            this.containerPreview = this.element.querySelector('.js-generic-form-preview');
        }
        if (this.element.querySelector('.js-generic-form-preview-modal')) {
            this.containerPreviewModal = this.element.querySelector('.js-generic-form-preview-modal');
        }
        if (this.element.querySelector('.form-builder__output--parsedjson')) {
            this.containerParseJSON = this.element.querySelector('.form-builder__output--parsedjson');
        }
        if (this.element.querySelector('.js-copy-html-clipboard')) {
            this.buttonCopyHTML = this.element.querySelector('.js-copy-html-clipboard');
        }
        if (this.element.querySelector('.js-copy-json-clipboard')) {
            this.buttonCopyJSON = this.element.querySelector('.js-copy-json-clipboard');
        }
        if (this.element.querySelector('.form-builder__container--field__submit')) {
            this.containerSubmitButton = this.element.querySelector('.form-builder__container--field__submit');
        }
        this.selectedField = null;
        this.hasFocus = false;
        if (this.element.querySelector('.js-copy-json-clipboard')) {
            this.addFieldHeading();
            this.addFieldParagraph();
            this.addFieldInput();
        }
    };
    FormBuilder.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonConverter) {
            this.buttonConverter.map(function (item) { return item.addEventListener('click', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var getForm = element.closest('form');
                var formType = getForm.getAttribute('data-type');
                _this.containerModal = _this.element.querySelector('.form-container');
                var getOutput = _this.element.querySelector('.form-builder__output');
                _this.createForm(getOutput, formType);
            }); });
        }
        if (this.inputs) {
            this.inputs.map(function (input) { return input.addEventListener('keyup', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                if (element.closest('.form-builder__general')) {
                }
                else {
                    var getForm = element.closest('form');
                    var formType = getForm.getAttribute('data-type');
                    _this.containerModal = _this.element.querySelector('.form-container');
                    var getOutput = _this.element.querySelector('.form-builder__output');
                    _this.createForm(getOutput, formType);
                }
            }); });
            this.inputs.map(function (input) { return input.addEventListener('paste', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                if (element.closest('.form-builder__general')) {
                }
                else {
                    var getForm = element.closest('form');
                    var formType_1 = getForm.getAttribute('data-type');
                    _this.containerModal = _this.element.querySelector('.form-container');
                    var getOutput_1 = _this.element.querySelector('.form-builder__output');
                    setTimeout(function () {
                        _this.createForm(getOutput_1, formType_1);
                    }, 200);
                }
            }); });
        }
        if (this.inputFormHeading) {
            this.inputFormHeading.addEventListener('keyup', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var previewGenericFormModal = _this.element.querySelector('#preview-generic-eform');
                var change = previewGenericFormModal.querySelector('.apply-now__section-header .title');
                change.innerHTML = element.value;
                _this.buildPreview();
            });
        }
        if (this.inputFormAnalytics) {
            this.inputFormAnalytics.addEventListener('keyup', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var previewGenericFormModal = _this.element.querySelector('#preview-generic-eform');
                var change = previewGenericFormModal.querySelector('form');
                change.setAttribute('data-frmcontainer', element.value);
                _this.buildPreview();
            });
        }
        if (this.inputFormRecipient) {
            this.inputFormRecipient.addEventListener('keyup', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var previewGenericFormModal = _this.element.querySelector('#preview-generic-eform');
                var change = previewGenericFormModal.querySelector("input[name='recipient']");
                change.setAttribute('value', element.value);
                _this.buildPreview();
            });
        }
        if (this.inputFormEmail) {
            this.inputFormEmail.addEventListener('keyup', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var previewGenericFormModal = _this.element.querySelector('#preview-generic-eform');
                var change = previewGenericFormModal.querySelector("input[name='email']");
                change.setAttribute('value', element.value);
                _this.buildPreview();
            });
        }
        if (this.inputFormSubject) {
            this.inputFormSubject.addEventListener('keyup', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var previewGenericFormModal = _this.element.querySelector('#preview-generic-eform');
                var change = previewGenericFormModal.querySelector("input[name='subject']");
                change.setAttribute('value', element.value);
                _this.buildPreview();
            });
        }
        if (this.inputFormButton) {
            this.inputFormButton.addEventListener('keyup', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var previewGenericFormModal = _this.element.querySelector('#preview-generic-eform');
                var parent = element.closest('.form-builder__container--field__submit');
                var title = parent.querySelector('.form-builder__container--field__title');
                var change = previewGenericFormModal.querySelector("input[name='subject']");
                change.setAttribute('value', element.value);
                title.innerHTML = element.value;
                _this.buildPreview();
            });
        }
        if (this.buttonFieldAddHeading) {
            this.buttonFieldAddHeading.addEventListener('click', function (event) {
                _this.addFieldHeading();
            });
        }
        if (this.buttonFieldAddParagraph) {
            this.buttonFieldAddParagraph.addEventListener('click', function (event) {
                _this.addFieldParagraph();
            });
        }
        if (this.buttonFieldAddInput) {
            this.buttonFieldAddInput.addEventListener('click', function (event) {
                _this.addFieldInput();
            });
        }
        if (this.buttonFieldAddInputNumber) {
            this.buttonFieldAddInputNumber.addEventListener('click', function (event) {
                _this.addFieldInputNumber();
            });
        }
        if (this.buttonFieldAddInputEmail) {
            this.buttonFieldAddInputEmail.addEventListener('click', function (event) {
                _this.addFieldInputEmail();
            });
        }
        if (this.buttonFieldAddTextarea) {
            this.buttonFieldAddTextarea.addEventListener('click', function (event) {
                _this.addFieldTextarea();
            });
        }
        if (this.buttonFieldAddDate) {
            this.buttonFieldAddDate.addEventListener('click', function (event) {
                _this.addFieldDate();
            });
        }
        if (this.buttonFieldAddDropdown) {
            this.buttonFieldAddDropdown.addEventListener('click', function (event) {
                _this.addFieldDropdown();
            });
        }
        if (this.buttonFieldAddIconText) {
            this.buttonFieldAddIconText.addEventListener('click', function (event) {
                _this.addFieldIconText();
            });
        }
        if (this.buttonFieldAddCheckbox) {
            this.buttonFieldAddCheckbox.addEventListener('click', function (event) {
                _this.addFieldCheckbox();
            });
        }
        if (this.buttonFieldAddRadioButton) {
            this.buttonFieldAddRadioButton.addEventListener('click', function (event) {
                _this.addFieldRadio();
            });
        }
        if (this.buttonFieldAddIdNumber) {
            this.buttonFieldAddIdNumber.addEventListener('click', function (event) {
                _this.addFieldIdPassport();
            });
        }
        if (this.buttonFieldAddCountries) {
            this.buttonFieldAddCountries.addEventListener('click', function (event) {
                _this.addFieldCountries();
            });
        }
        if (this.buttonFieldAddProvince) {
            this.buttonFieldAddProvince.addEventListener('click', function (event) {
                _this.addFieldProvinces();
            });
        }
        if (this.containerParseJSON) {
            this.containerParseJSON.addEventListener('paste', function (event) {
                _this.buildJSON(event);
            });
            this.containerParseJSON.addEventListener('keyup', function (event) {
                _this.buildJSON(event);
            });
        }
        if (this.buttonCopyHTML) {
            this.buttonCopyHTML.addEventListener('click', function (event) {
                /* Select the text field */
                var containerCopyHTML = document.getElementById("outputHtml");
                containerCopyHTML.select();
                containerCopyHTML.setSelectionRange(0, 99999); /*For mobile devices*/
                /* Copy the text inside the text field */
                document.execCommand("copy");
                console.log('Copied HTML');
            });
        }
        if (this.buttonCopyJSON) {
            this.buttonCopyJSON.addEventListener('click', function (event) {
                /* Select the text field */
                var containerCopyJSON = document.getElementById("outputJson");
                containerCopyJSON.select();
                containerCopyJSON.setSelectionRange(0, 99999); /*For mobile devices*/
                /* Copy the text inside the text field */
                document.execCommand("copy");
                console.log('Copied JSON');
            });
        }
        if (this.containerSubmitButton) {
            this.containerSubmitButton.addEventListener('click', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var containerSettingsAll = Array.from(_this.element.querySelectorAll('.form-builder__container--field__settings'));
                containerSettingsAll.map(function (container) {
                    container.classList.remove('open');
                });
                var settings = element.querySelector('.form-builder__container--field__settings');
                settings.classList.add('open');
            });
        }
        this.generatedJSON = [];
    };
    FormBuilder.prototype.createForm = function (output, type) {
        var content = "";
        // fields
        var getFieldDescription = this.element.querySelector('input[name=form-builder_field--description');
        var getFieldTitleLabel = this.element.querySelector('input[name=form-builder_field--title__label');
        var getFieldTitleOption1 = this.element.querySelector('input[name=form-builder_field--title__value--1');
        var getFieldTitleOption2 = this.element.querySelector('input[name=form-builder_field--title__value--2');
        var getFieldTitleOption3 = this.element.querySelector('input[name=form-builder_field--title__value--3');
        var getFieldTitleOption4 = this.element.querySelector('input[name=form-builder_field--title__value--4');
        var getFieldTitleOption5 = this.element.querySelector('input[name=form-builder_field--title__value--5');
        var getFieldFirstnameLabel = this.element.querySelector('input[name=form-builder_field--firstname__label');
        var getFieldFirstnamePlaceholder = this.element.querySelector('input[name=form-builder_field--firstname__placeholder');
        var getFieldSurnameLabel = this.element.querySelector('input[name=form-builder_field--surname__label');
        var getFieldSurnamePlaceholder = this.element.querySelector('input[name=form-builder_field--surname__placeholder');
        var getFieldTelephoneLabel = this.element.querySelector('input[name=form-builder_field--telephone__label');
        var getFieldTelephonePlaceholder = this.element.querySelector('input[name=form-builder_field--telephone__placeholder');
        var getFieldEmailLabel = this.element.querySelector('input[name=form-builder_field--email__label');
        var getFieldEmailPlaceholder = this.element.querySelector('input[name=form-builder_field--email__placeholder');
        var getFieldQueryLabel = this.element.querySelector('input[name=form-builder_field--query__label');
        var getFieldQueryPlaceholder = this.element.querySelector('input[name=form-builder_field--query__placeholder');
        var getFieldLockValue = this.element.querySelector('input[name=form-builder_field--lock');
        var getFieldButtonValue = this.element.querySelector('input[name=form-builder_field--button');
        var valueDescription = 'Fill in your information and let us call you';
        var valueTitleLabel = 'Title';
        var valueTitleValue1 = 'Mr';
        var valueTitleValue2 = 'Mrs';
        var valueTitleValue3 = 'Miss';
        var valueTitleValue4 = 'Ms';
        var valueTitleValue5 = 'Other';
        var valueFirstnameLabel = 'First Name';
        var valueFirstnamePlaceholder = 'Enter your first name';
        var valueSurnameLabel = 'Surname';
        var valueSurnamePlaceholder = 'Enter your surname';
        var valueTelephoneLabel = 'Telephone Number';
        var valueTelephonePlaceholder = 'Enter your telephone number';
        var valueEmailLabel = 'Email Address';
        var valueEmailPlaceholder = 'Enter your email address';
        var valueQueryLabel = 'Query / Comments';
        var valueQueryPlaceholder = 'Enter your query or comments';
        var valueLockValue = 'Your information will be managed securely.';
        var valueButtonValue = 'Call me back';
        if (getFieldDescription.value !== '') {
            valueDescription = getFieldDescription.value;
        }
        if (getFieldTitleLabel.value !== '') {
            valueTitleLabel = getFieldTitleLabel.value;
        }
        if (getFieldTitleOption1.value !== '') {
            valueTitleValue1 = getFieldTitleOption1.value;
        }
        if (getFieldTitleOption2.value !== '') {
            valueTitleValue2 = getFieldTitleOption2.value;
        }
        if (getFieldTitleOption3.value !== '') {
            valueTitleValue3 = getFieldTitleOption3.value;
        }
        if (getFieldTitleOption4.value !== '') {
            valueTitleValue4 = getFieldTitleOption4.value;
        }
        if (getFieldTitleOption5.value !== '') {
            valueTitleValue5 = getFieldTitleOption5.value;
        }
        if (getFieldFirstnameLabel.value !== '') {
            valueFirstnameLabel = getFieldFirstnameLabel.value;
        }
        if (getFieldFirstnamePlaceholder.value !== '') {
            valueFirstnamePlaceholder = getFieldFirstnamePlaceholder.value;
        }
        if (getFieldSurnameLabel.value !== '') {
            valueSurnameLabel = getFieldSurnameLabel.value;
        }
        if (getFieldSurnamePlaceholder.value !== '') {
            valueSurnamePlaceholder = getFieldSurnamePlaceholder.value;
        }
        if (getFieldTelephoneLabel.value !== '') {
            valueTelephoneLabel = getFieldTelephoneLabel.value;
        }
        if (getFieldTelephonePlaceholder.value !== '') {
            valueTelephonePlaceholder = getFieldTelephonePlaceholder.value;
        }
        if (getFieldEmailLabel.value !== '') {
            valueEmailLabel = getFieldEmailLabel.value;
        }
        if (getFieldEmailPlaceholder.value !== '') {
            valueEmailPlaceholder = getFieldEmailPlaceholder.value;
        }
        if (getFieldQueryLabel.value !== '') {
            valueQueryLabel = getFieldQueryLabel.value;
        }
        if (getFieldQueryPlaceholder.value !== '') {
            valueQueryPlaceholder = getFieldQueryPlaceholder.value;
        }
        if (getFieldLockValue.value !== '') {
            valueLockValue = getFieldLockValue.value;
        }
        if (getFieldButtonValue.value !== '') {
            valueButtonValue = getFieldButtonValue.value;
        }
        // content
        var getFormName = this.element.querySelector('input[name=form-builder__name]');
        var getFormRecipient = this.element.querySelector('input[name=form-builder__recipient]');
        var getFormEmail = this.element.querySelector('input[name=form-builder__email]');
        var getFormSubject = this.element.querySelector('input[name=form-builder__subject]');
        if (type === 'nigeria-account-enquiry') {
            var getFormProduct = this.element.querySelector('input[name=form-builder__product]');
            content = "<form class=\"form\" id=\"apply-now-submit_application_mail\"\n\t\t\t\tdata-frmcontainer=\"" + getFormName.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"recipient\"\n\t\t\t\t\tvalue=\"" + getFormRecipient.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"email\"\n\t\t\t\t\tvalue=\"" + getFormEmail.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"subject\" value=\"" + getFormSubject.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"redirect\" value=\"\">\n\t\t\t\t<input type=\"hidden\" name=\"product\" value=\"" + getFormProduct.value + "\">\n\t\t\t\t<div class=\"form__loader--container\">\n\t\t\t\t\t<img class=\"search__results-busy\"\n\t\t\t\t\t\tsrc=\"/file_source/assets/img/spinner.gif\" />\n\t\t\t\t</div>\n\t\t\t\t<div class=\"form__fields--container\">\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<p style=\"margin-bottom: 0px;\">" + valueDescription + "</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueTitleLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<div class=\"form__select\">\n\t\t\t\t\t\t\t<select name=\"title\" class=\"form__input  form__input--required \njs-title \">\n\t\t\t\t\t\t\t\t<option value=\"Mr\">" + valueTitleValue1 + "</option>\n\t\t\t\t\t\t\t\t<option value=\"Mrs\">" + valueTitleValue2 + "</option>\n\t\t\t\t\t\t\t\t<option value=\"Miss\">" + valueTitleValue3 + "</option>\n\t\t\t\t\t\t\t\t<option value=\"Ms\">" + valueTitleValue4 + "</option>\n\t\t\t\t\t\t\t\t<option value=\"Other\">" + valueTitleValue5 + "</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueFirstnameLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<input type=\"text\" name=\"first-name\" value=\"\" maxlength=\"40\"\n\t\t\t\t\t\t\tclass=\"form__input  form__input--required  \nform__input--minmaxLength \n\" placeholder=\"" + valueFirstnamePlaceholder + "\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueSurnameLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<input type=\"text\" name=\"surname\" value=\"\" maxlength=\"20\" class=\"form__input  form__input--required  \nform__input--minmaxLength \n\" placeholder=\"" + valueSurnamePlaceholder + "\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueTelephoneLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<input type=\"number\" name=\"telephone-number\" value=\"\" class=\"form__input  form__input--required  \n\" placeholder=\"" + valueTelephonePlaceholder + "\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueEmailLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<input type=\"text\" name=\"emailAddress\" value=\"\" class=\"form__input  \nform__input--email \n\" placeholder=\"" + valueEmailPlaceholder + "\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueQueryLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<textarea name=\"comments\" value=\"\" maxlength=\"200\" class=\"form__textarea  \nform__input--minmaxLength \n\" placeholder=\"" + valueQueryPlaceholder + "\" rows=\"5\"></textarea>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"apply-now__note\">\n\t\t\t\t\t\t<div class=\"apply-now__note-icon\">\n\t\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-lock\"\n\t\t\t\t\t\t\t\tdata-gradient=\"\" data-path=\"/file_source/assets/icons/\"\n\t\t\t\t\t\t\t\tclass=\"icon \">\n\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"apply-now__note-text\">\n\t\t\t\t\t\t\t" + valueLockValue + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"apply-now__buttons\">\n\t\t\t\t\t\t<a class=\"button button--medium apply-now__button js-apply-now__button\"\n\t\t\t\t\t\t\thref=\"javascript:void(0);\" target=\"\" data-modal=\"\"\n\t\t\t\t\t\t\tdata-id=\"\" data-text=\"\">\n\t\t\t\t\t\t\t" + valueButtonValue + "\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"form__thankyou--container js-apply-now-success-message\">\n\t\t\t\t\t<div\n\t\t\t\t\t\tclass=\"title title--module-sub-title text-center enquiry__title\">\n\t\t\t\t\t\tThank you for your interest in our 'ProductName' </div>\n\t\t\t\t\t<p>One of our consultants will be in contact with you</p>\n\t\t\t\t\t<div class=\"form__success--image\">\n\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"form-complete\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\"\n\t\t\t\t\t\t\tclass=\"icon \">\n\t\t\t\t\t\t\t<!--?xml version=\"1.0\" encoding=\"UTF-8\"?--><svg xmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t\t\t\txmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"127px\" height=\"118px\" viewBox=\"0 0 127 118\" version=\"1.1\">\n\t\t\t\t\t\t\t\t<title>Group 4</title>\n\t\t\t\t\t\t\t\t<g id=\"Success-Messages\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t\t\t<g id=\"Success-message-\" transform=\"translate(-686.000000, -882.000000)\">\n\t\t\t\t\t\t\t\t\t\t<g id=\"Group-4\" transform=\"translate(687.000000, 883.000000)\">\n\t\t\t\t\t\t\t\t\t\t\t<g id=\"Group\">\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M106.4448,38.5349293 L106.4448,89.4262698 C106.4448,96.1257337 100.549937,101.6064 93.3440832,101.6064 L13.1007168,101.6064 C5.89617554,101.6064 0,96.1257337 0,89.4262698 L0,38.5349293 C0,37.5842148 0.160100916,36.6335004 0.478990445,35.7311716 C0.585286955,35.39901 0.691583465,35.1139265 0.851684381,34.8275352 C0.957980891,34.5424516 1.11808181,34.3057538 1.27687042,34.0206702 C3.08784799,31.0743707 6.59956973,29.0304 10.6440863,29.0304 L95.8007137,29.0304 C99.8452303,29.0304 103.358264,31.0743707 105.16793,34.0206702 C105.326718,34.3057538 105.486819,34.5424516 105.593116,34.8275352 C105.753217,35.1139265 105.859513,35.39901 105.96581,35.7311716 C106.284699,36.6335004 106.4448,37.5842148 106.4448,38.5349293\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-5\" fill=\"#C4E4FF\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M106.4448,38.5349293 L106.4448,89.4262698 C106.4448,96.1257337 100.549937,101.6064 93.3440832,101.6064 L13.1007168,101.6064 C5.89617554,101.6064 0,96.1257337 0,89.4262698 L0,38.5349293 C0,37.5842148 0.160100916,36.6335004 0.478990445,35.7311716 C0.585286955,35.39901 0.691583465,35.1139265 0.851684381,34.8275352 C0.957980891,34.5424516 1.11808181,34.3057538 1.27687042,34.0206702 C3.08784799,31.0743707 6.59956973,29.0304 10.6440863,29.0304 L95.8007137,29.0304 C99.8452303,29.0304 103.358264,31.0743707 105.16793,34.0206702 C105.326718,34.3057538 105.486819,34.5424516 105.593116,34.8275352 C105.753217,35.1139265 105.859513,35.39901 105.96581,35.7311716 C106.284699,36.6335004 106.4448,37.5842148 106.4448,38.5349293 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-7\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linejoin=\"round\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M0,40.0640948 C0,36.7352797 1.49077574,33.3516528 4.52350703,31.0428721 L4.84239656,30.8289724 L45.658944,2.38030335 C50.2113217,-0.793434449 56.2334783,-0.793434449 60.785856,2.38030335 L101.601091,30.8289724 L101.921293,31.0428721 C104.954024,33.3516528 106.4448,36.7352797 106.4448,40.0640948 C106.4448,41.1376043 106.284699,42.2124506 105.96581,43.2324851 C105.859513,43.6081466 105.753217,43.9303331 105.593116,44.2525196 C105.486819,44.5747062 105.326718,44.8434177 105.16793,45.1656043 C103.356952,48.4944194 99.8452303,50.8032 95.8007137,50.8032 L10.6440863,50.8032 C6.59956973,50.8032 3.08653569,48.4944194 1.27687042,45.1656043 C1.11808181,44.8434177 0.957980891,44.5747062 0.851684381,44.2525196 C0.691583465,43.9303331 0.585286955,43.6081466 0.478990445,43.2324851 C0.160100916,42.2124506 0,41.1376043 0,40.0640948\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-9\" fill=\"#9DD2FF\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M0,40.0640948 C0,36.7352797 1.49077574,33.3516528 4.52350703,31.0428721 L4.84239656,30.8289724 L45.658944,2.38030335 C50.2113217,-0.793434449 56.2334783,-0.793434449 60.785856,2.38030335 L101.601091,30.8289724 L101.921293,31.0428721 C104.954024,33.3516528 106.4448,36.7352797 106.4448,40.0640948 C106.4448,41.1376043 106.284699,42.2124506 105.96581,43.2324851 C105.859513,43.6081466 105.753217,43.9303331 105.593116,44.2525196 C105.486819,44.5747062 105.326718,44.8434177 105.16793,45.1656043 C103.356952,48.4944194 99.8452303,50.8032 95.8007137,50.8032 L10.6440863,50.8032 C6.59956973,50.8032 3.08653569,48.4944194 1.27687042,45.1656043 C1.11808181,44.8434177 0.957980891,44.5747062 0.851684381,44.2525196 C0.691583465,43.9303331 0.585286955,43.6081466 0.478990445,43.2324851 C0.160100916,42.2124506 0,41.1376043 0,40.0640948 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-11\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linejoin=\"round\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M91.9296,50.8032 L91.9296,8.98629601 C91.9296,8.03092904 90.7188472,7.2576 89.223443,7.2576 L14.802157,7.2576 C13.3067528,7.2576 12.096,8.03092904 12.096,8.98629601 L12.096,50.8032 L91.9296,50.8032 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-13\" fill=\"#FFFFFF\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M91.9296,50.8032 L91.9296,8.98629601 C91.9296,8.03092904 90.7188472,7.2576 89.223443,7.2576 L14.802157,7.2576 C13.3067528,7.2576 12.096,8.03092904 12.096,8.98629601 L12.096,50.8032 L91.9296,50.8032 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-15\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linecap=\"round\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-17\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 19.3536 84.672 19.3536 84.672 16.9344 21.7728 16.9344\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-19\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 24.192 67.7376 24.192 67.7376 21.7728 21.7728 21.7728\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-20\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 36.288 84.672 36.288 84.672 33.8688 21.7728 33.8688\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-21\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 43.5456 67.7376 43.5456 67.7376 41.1264 21.7728 41.1264\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t\t\t<g id=\"Group-5-Copy\" transform=\"translate(67.200000, 58.800000)\">\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M57.257088,28.628544 C57.257088,44.43936 44.43936,57.257088 28.628544,57.257088 C12.817728,57.257088 5.72981662e-14,44.43936 5.72981662e-14,28.628544 C5.72981662e-14,12.817728 12.817728,5.72981662e-14 28.628544,5.72981662e-14 C44.43936,5.72981662e-14 57.257088,12.817728 57.257088,28.628544\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-22\" fill=\"#4AA740\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M57.257088,28.628544 C57.257088,44.43936 44.43936,57.257088 28.628544,57.257088 C12.817728,57.257088 5.72981662e-14,44.43936 5.72981662e-14,28.628544 C5.72981662e-14,12.817728 12.817728,5.72981662e-14 28.628544,5.72981662e-14 C44.43936,5.72981662e-14 57.257088,12.817728 57.257088,28.628544 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-23\" stroke=\"#0033AA\" stroke-width=\"1.344\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<polyline id=\"Stroke-24\" stroke=\"#FFFFFF\" stroke-width=\"2.688\" stroke-linecap=\"round\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"15.067584 30.1353024 24.108672 39.1763904 42.189504 18.0809664\"></polyline>\n\t\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t</i>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\t\t\t</form>";
        }
        else if (type === 'nigeria-need-help') {
            content = "<form class=\"form\" id=\"apply-now-submit_application_mail\"\n\t\t\t\tdata-frmcontainer=\"" + getFormName.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"recipient\"\n\t\t\t\t\tvalue=\"" + getFormRecipient.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"email\"\n\t\t\t\t\tvalue=\"" + getFormEmail.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"subject\" value=\"" + getFormSubject.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"redirect\" value=\"\">\n\t\t\t\t<div class=\"form__loader--container\">\n\t\t\t\t\t<img class=\"search__results-busy\"\n\t\t\t\t\t\tsrc=\"/file_source/assets/img/spinner.gif\" />\n\t\t\t\t</div>\n\t\t\t\t<div class=\"form__fields--container\">\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<p style=\"margin-bottom: 0px;\">" + valueDescription + "</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueTitleLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<div class=\"form__select\">\n\t\t\t\t\t\t\t<select name=\"title\" class=\"form__input  form__input--required \n\tjs-title \">\n\t\t\t\t\t\t\t\t<option value=\"Mr\">" + valueTitleValue1 + "</option>\n\t\t\t\t\t\t\t\t<option value=\"Mrs\">" + valueTitleValue2 + "</option>\n\t\t\t\t\t\t\t\t<option value=\"Miss\">" + valueTitleValue3 + "</option>\n\t\t\t\t\t\t\t\t<option value=\"Ms\">" + valueTitleValue4 + "</option>\n\t\t\t\t\t\t\t\t<option value=\"Other\">" + valueTitleValue5 + "</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueFirstnameLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<input type=\"text\" name=\"first-name\" value=\"\" maxlength=\"40\"\n\t\t\t\t\t\t\tclass=\"form__input  form__input--required  \n\tform__input--minmaxLength \n\t\" placeholder=\"" + valueFirstnamePlaceholder + "\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueSurnameLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<input type=\"text\" name=\"surname\" value=\"\" maxlength=\"20\" class=\"form__input  form__input--required  \n\tform__input--minmaxLength \n\t\" placeholder=\"" + valueSurnamePlaceholder + "\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueTelephoneLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<input type=\"number\" name=\"telephone-number\" value=\"\" class=\"form__input  form__input--required  \n\n\t\" placeholder=\"" + valueTelephonePlaceholder + "\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueEmailLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<input type=\"text\" name=\"emailAddress\" value=\"\" class=\"form__input  \n\tform__input--email \n\t\" placeholder=\"" + valueEmailPlaceholder + "\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueQueryLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<textarea name=\"comments\" value=\"\" maxlength=\"200\" class=\"form__textarea  \n\tform__input--minmaxLength \n\t\" placeholder=\"" + valueQueryPlaceholder + "\" rows=\"5\"></textarea>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"apply-now__note\">\n\t\t\t\t\t\t<div class=\"apply-now__note-icon\">\n\t\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-lock\"\n\t\t\t\t\t\t\t\tdata-gradient=\"\" data-path=\"/file_source/assets/icons/\"\n\t\t\t\t\t\t\t\tclass=\"icon \">\n\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"apply-now__note-text\">\n\t\t\t\t\t\t\t" + valueLockValue + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"apply-now__buttons\">\n\t\t\t\t\t\t<a class=\"button button--medium apply-now__button js-apply-now__button\"\n\t\t\t\t\t\t\thref=\"javascript:void(0);\" target=\"\" data-modal=\"\"\n\t\t\t\t\t\t\tdata-id=\"\" data-text=\"\">\n\t\t\t\t\t\t\t" + valueButtonValue + "\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"form__thankyou--container js-apply-now-success-message\">\n\t\t\t\t\t<div\n\t\t\t\t\t\tclass=\"title title--module-sub-title text-center enquiry__title\">\n\t\t\t\t\t\tThank you for enquiring</div>\n\t\t\t\t\t<p>One of our consultants will be in contact with you to assist you\n\t\t\t\t\t\twith your enquiry</p>\n\t\t\t\t\t<div class=\"form__success--image\">\n\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"form-complete\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\"\n\t\t\t\t\t\t\tclass=\"icon \">\n\t\t\t\t\t\t\t<!--?xml version=\"1.0\" encoding=\"UTF-8\"?--><svg xmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t\t\t\txmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"127px\" height=\"118px\" viewBox=\"0 0 127 118\" version=\"1.1\">\n\t\t\t\t\t\t\t\t<title>Group 4</title>\n\t\t\t\t\t\t\t\t<g id=\"Success-Messages\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t\t\t<g id=\"Success-message-\" transform=\"translate(-686.000000, -882.000000)\">\n\t\t\t\t\t\t\t\t\t\t<g id=\"Group-4\" transform=\"translate(687.000000, 883.000000)\">\n\t\t\t\t\t\t\t\t\t\t\t<g id=\"Group\">\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M106.4448,38.5349293 L106.4448,89.4262698 C106.4448,96.1257337 100.549937,101.6064 93.3440832,101.6064 L13.1007168,101.6064 C5.89617554,101.6064 0,96.1257337 0,89.4262698 L0,38.5349293 C0,37.5842148 0.160100916,36.6335004 0.478990445,35.7311716 C0.585286955,35.39901 0.691583465,35.1139265 0.851684381,34.8275352 C0.957980891,34.5424516 1.11808181,34.3057538 1.27687042,34.0206702 C3.08784799,31.0743707 6.59956973,29.0304 10.6440863,29.0304 L95.8007137,29.0304 C99.8452303,29.0304 103.358264,31.0743707 105.16793,34.0206702 C105.326718,34.3057538 105.486819,34.5424516 105.593116,34.8275352 C105.753217,35.1139265 105.859513,35.39901 105.96581,35.7311716 C106.284699,36.6335004 106.4448,37.5842148 106.4448,38.5349293\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-5\" fill=\"#C4E4FF\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M106.4448,38.5349293 L106.4448,89.4262698 C106.4448,96.1257337 100.549937,101.6064 93.3440832,101.6064 L13.1007168,101.6064 C5.89617554,101.6064 0,96.1257337 0,89.4262698 L0,38.5349293 C0,37.5842148 0.160100916,36.6335004 0.478990445,35.7311716 C0.585286955,35.39901 0.691583465,35.1139265 0.851684381,34.8275352 C0.957980891,34.5424516 1.11808181,34.3057538 1.27687042,34.0206702 C3.08784799,31.0743707 6.59956973,29.0304 10.6440863,29.0304 L95.8007137,29.0304 C99.8452303,29.0304 103.358264,31.0743707 105.16793,34.0206702 C105.326718,34.3057538 105.486819,34.5424516 105.593116,34.8275352 C105.753217,35.1139265 105.859513,35.39901 105.96581,35.7311716 C106.284699,36.6335004 106.4448,37.5842148 106.4448,38.5349293 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-7\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linejoin=\"round\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M0,40.0640948 C0,36.7352797 1.49077574,33.3516528 4.52350703,31.0428721 L4.84239656,30.8289724 L45.658944,2.38030335 C50.2113217,-0.793434449 56.2334783,-0.793434449 60.785856,2.38030335 L101.601091,30.8289724 L101.921293,31.0428721 C104.954024,33.3516528 106.4448,36.7352797 106.4448,40.0640948 C106.4448,41.1376043 106.284699,42.2124506 105.96581,43.2324851 C105.859513,43.6081466 105.753217,43.9303331 105.593116,44.2525196 C105.486819,44.5747062 105.326718,44.8434177 105.16793,45.1656043 C103.356952,48.4944194 99.8452303,50.8032 95.8007137,50.8032 L10.6440863,50.8032 C6.59956973,50.8032 3.08653569,48.4944194 1.27687042,45.1656043 C1.11808181,44.8434177 0.957980891,44.5747062 0.851684381,44.2525196 C0.691583465,43.9303331 0.585286955,43.6081466 0.478990445,43.2324851 C0.160100916,42.2124506 0,41.1376043 0,40.0640948\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-9\" fill=\"#9DD2FF\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M0,40.0640948 C0,36.7352797 1.49077574,33.3516528 4.52350703,31.0428721 L4.84239656,30.8289724 L45.658944,2.38030335 C50.2113217,-0.793434449 56.2334783,-0.793434449 60.785856,2.38030335 L101.601091,30.8289724 L101.921293,31.0428721 C104.954024,33.3516528 106.4448,36.7352797 106.4448,40.0640948 C106.4448,41.1376043 106.284699,42.2124506 105.96581,43.2324851 C105.859513,43.6081466 105.753217,43.9303331 105.593116,44.2525196 C105.486819,44.5747062 105.326718,44.8434177 105.16793,45.1656043 C103.356952,48.4944194 99.8452303,50.8032 95.8007137,50.8032 L10.6440863,50.8032 C6.59956973,50.8032 3.08653569,48.4944194 1.27687042,45.1656043 C1.11808181,44.8434177 0.957980891,44.5747062 0.851684381,44.2525196 C0.691583465,43.9303331 0.585286955,43.6081466 0.478990445,43.2324851 C0.160100916,42.2124506 0,41.1376043 0,40.0640948 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-11\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linejoin=\"round\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M91.9296,50.8032 L91.9296,8.98629601 C91.9296,8.03092904 90.7188472,7.2576 89.223443,7.2576 L14.802157,7.2576 C13.3067528,7.2576 12.096,8.03092904 12.096,8.98629601 L12.096,50.8032 L91.9296,50.8032 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-13\" fill=\"#FFFFFF\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M91.9296,50.8032 L91.9296,8.98629601 C91.9296,8.03092904 90.7188472,7.2576 89.223443,7.2576 L14.802157,7.2576 C13.3067528,7.2576 12.096,8.03092904 12.096,8.98629601 L12.096,50.8032 L91.9296,50.8032 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-15\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linecap=\"round\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-17\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 19.3536 84.672 19.3536 84.672 16.9344 21.7728 16.9344\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-19\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 24.192 67.7376 24.192 67.7376 21.7728 21.7728 21.7728\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-20\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 36.288 84.672 36.288 84.672 33.8688 21.7728 33.8688\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-21\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 43.5456 67.7376 43.5456 67.7376 41.1264 21.7728 41.1264\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t\t\t<g id=\"Group-5-Copy\" transform=\"translate(67.200000, 58.800000)\">\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M57.257088,28.628544 C57.257088,44.43936 44.43936,57.257088 28.628544,57.257088 C12.817728,57.257088 5.72981662e-14,44.43936 5.72981662e-14,28.628544 C5.72981662e-14,12.817728 12.817728,5.72981662e-14 28.628544,5.72981662e-14 C44.43936,5.72981662e-14 57.257088,12.817728 57.257088,28.628544\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-22\" fill=\"#4AA740\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M57.257088,28.628544 C57.257088,44.43936 44.43936,57.257088 28.628544,57.257088 C12.817728,57.257088 5.72981662e-14,44.43936 5.72981662e-14,28.628544 C5.72981662e-14,12.817728 12.817728,5.72981662e-14 28.628544,5.72981662e-14 C44.43936,5.72981662e-14 57.257088,12.817728 57.257088,28.628544 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-23\" stroke=\"#0033AA\" stroke-width=\"1.344\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<polyline id=\"Stroke-24\" stroke=\"#FFFFFF\" stroke-width=\"2.688\" stroke-linecap=\"round\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"15.067584 30.1353024 24.108672 39.1763904 42.189504 18.0809664\"></polyline>\n\t\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t</i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</form>";
        }
        else {
            var getFieldFeedbackLabel = this.element.querySelector('input[name=form-builder_field--feedback__label');
            var getFieldFeedbackCompliment = this.element.querySelector('input[name=form-builder_field--feedback__compliment');
            var getFieldFeedbackComplaint = this.element.querySelector('input[name=form-builder_field--feedback__complaint');
            var valueFeedbackLabel = 'Feedback Type';
            var valueFeedbackCompliment = 'Compliment';
            var valueFeedbackComplaint = 'Complaint';
            if (getFieldFeedbackLabel.value !== '') {
                valueFeedbackLabel = getFieldFeedbackLabel.value;
            }
            if (getFieldFeedbackCompliment.value !== '') {
                valueFeedbackCompliment = getFieldFeedbackCompliment.value;
            }
            if (getFieldFeedbackComplaint.value !== '') {
                valueFeedbackComplaint = getFieldFeedbackComplaint.value;
            }
            content = "<form class=\"form\" id=\"apply-now-submit_application_mail\"\n\t\t\t\tdata-frmcontainer=\"" + getFormName.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"recipient\"\n\t\t\t\t\tvalue=\"" + getFormRecipient.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"email\"\n\t\t\t\t\tvalue=\"" + getFormEmail.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"subject\" value=\"" + getFormSubject.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"redirect\" value=\"\">\n\t\t\t\t<div class=\"form__loader--container\">\n\t\t\t\t\t<img class=\"search__results-busy\"\n\t\t\t\t\t\tsrc=\"/file_source/assets/img/spinner.gif\" />\n\t\t\t\t</div>\n\t\t\t\t<div class=\"form__fields--container\">\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<p style=\"margin-bottom: 0px;\">" + valueDescription + "</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueFeedbackLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<div class=\"apply-now__radio\">\n\t\t\t\t\t\t\t<label class=\"form__control form__control--radio\">\n\t\t\t\t\t\t\t" + valueFeedbackCompliment + "\n\t\t\t\t\t\t\t\t<input type=\"radio\" name=\"feedback_type\"\n\t\t\t\t\t\t\t\t\tvalue=\"compliment\"\n\t\t\t\t\t\t\t\t\tclass='js-identification_radio--group js-feedback-type__radio' />\n\t\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<label class=\"form__control form__control--radio\">\n\t\t\t\t\t\t\t\t" + valueFeedbackComplaint + "\n\t\t\t\t\t\t\t\t<input type=\"radio\" name=\"feedback_type\"\n\t\t\t\t\t\t\t\t\tvalue=\"complaint\"\n\t\t\t\t\t\t\t\t\tclass='js-identification_radio--group js-feedback-type__radio' />\n\t\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueTitleLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<div class=\"form__select\">\n\t\t\t\t\t\t\t<select name=\"title\" class=\"form__input  form__input--required \n\tjs-title \">\n\t\t\t\t\t\t\t\t<option value=\"Mr\">" + valueTitleValue1 + "</option>\n\t\t\t\t\t\t\t\t<option value=\"Mrs\">" + valueTitleValue2 + "</option>\n\t\t\t\t\t\t\t\t<option value=\"Miss\">" + valueTitleValue3 + "</option>\n\t\t\t\t\t\t\t\t<option value=\"Ms\">" + valueTitleValue4 + "</option>\n\t\t\t\t\t\t\t\t<option value=\"Other\">" + valueTitleValue5 + "</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueFirstnameLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<input type=\"text\" name=\"first-name\" value=\"\" maxlength=\"40\"\n\t\t\t\t\t\t\tclass=\"form__input  form__input--required  \n\tform__input--minmaxLength \n\t\" placeholder=\"" + valueFirstnamePlaceholder + "\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueSurnameLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<input type=\"text\" name=\"surname\" value=\"\" maxlength=\"20\" class=\"form__input  form__input--required  \n\tform__input--minmaxLength \n\t\" placeholder=\"" + valueSurnamePlaceholder + "\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueTelephoneLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<input type=\"number\" name=\"telephone-number\" value=\"\" class=\"form__input  form__input--required  \n\n\t\" placeholder=\"" + valueTelephonePlaceholder + "\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueEmailLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<input type=\"text\" name=\"emailAddress\" value=\"\" class=\"form__input  \n\tform__input--email \n\t\" placeholder=\"" + valueEmailPlaceholder + "\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t\t" + valueQueryLabel + "\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<textarea name=\"comments\" value=\"\" maxlength=\"200\" class=\"form__textarea  \n\tform__input--minmaxLength \n\t\" placeholder=\"" + valueQueryPlaceholder + "\" rows=\"5\"></textarea>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"apply-now__note\">\n\t\t\t\t\t\t<div class=\"apply-now__note-icon\">\n\t\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-lock\"\n\t\t\t\t\t\t\t\tdata-gradient=\"\" data-path=\"/file_source/assets/icons/\"\n\t\t\t\t\t\t\t\tclass=\"icon \">\n\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"apply-now__note-text\">\n\t\t\t\t\t\t\t" + valueLockValue + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"apply-now__buttons\">\n\t\t\t\t\t\t<a class=\"button button--medium apply-now__button js-apply-now__button\"\n\t\t\t\t\t\t\thref=\"javascript:void(0);\" target=\"\" data-modal=\"\"\n\t\t\t\t\t\t\tdata-id=\"\" data-text=\"\">\n\t\t\t\t\t\t\t" + valueButtonValue + "\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"form__thankyou--container js-apply-now-success-message\">\n\t\t\t\t\t<div\n\t\t\t\t\t\tclass=\"title title--module-sub-title text-center enquiry__title\">\n\t\t\t\t\t\tThank you for enquiring</div>\n\t\t\t\t\t<p>One of our consultants will be in contact with you to assist you\n\t\t\t\t\t\twith your enquiry</p>\n\t\t\t\t\t<div class=\"form__success--image\">\n\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"form-complete\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\"\n\t\t\t\t\t\t\tclass=\"icon \">\n\t\t\t\t\t\t\t<!--?xml version=\"1.0\" encoding=\"UTF-8\"?--><svg xmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t\t\t\txmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"127px\" height=\"118px\" viewBox=\"0 0 127 118\" version=\"1.1\">\n\t\t\t\t\t\t\t\t<title>Group 4</title>\n\t\t\t\t\t\t\t\t<g id=\"Success-Messages\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t\t\t<g id=\"Success-message-\" transform=\"translate(-686.000000, -882.000000)\">\n\t\t\t\t\t\t\t\t\t\t<g id=\"Group-4\" transform=\"translate(687.000000, 883.000000)\">\n\t\t\t\t\t\t\t\t\t\t\t<g id=\"Group\">\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M106.4448,38.5349293 L106.4448,89.4262698 C106.4448,96.1257337 100.549937,101.6064 93.3440832,101.6064 L13.1007168,101.6064 C5.89617554,101.6064 0,96.1257337 0,89.4262698 L0,38.5349293 C0,37.5842148 0.160100916,36.6335004 0.478990445,35.7311716 C0.585286955,35.39901 0.691583465,35.1139265 0.851684381,34.8275352 C0.957980891,34.5424516 1.11808181,34.3057538 1.27687042,34.0206702 C3.08784799,31.0743707 6.59956973,29.0304 10.6440863,29.0304 L95.8007137,29.0304 C99.8452303,29.0304 103.358264,31.0743707 105.16793,34.0206702 C105.326718,34.3057538 105.486819,34.5424516 105.593116,34.8275352 C105.753217,35.1139265 105.859513,35.39901 105.96581,35.7311716 C106.284699,36.6335004 106.4448,37.5842148 106.4448,38.5349293\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-5\" fill=\"#C4E4FF\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M106.4448,38.5349293 L106.4448,89.4262698 C106.4448,96.1257337 100.549937,101.6064 93.3440832,101.6064 L13.1007168,101.6064 C5.89617554,101.6064 0,96.1257337 0,89.4262698 L0,38.5349293 C0,37.5842148 0.160100916,36.6335004 0.478990445,35.7311716 C0.585286955,35.39901 0.691583465,35.1139265 0.851684381,34.8275352 C0.957980891,34.5424516 1.11808181,34.3057538 1.27687042,34.0206702 C3.08784799,31.0743707 6.59956973,29.0304 10.6440863,29.0304 L95.8007137,29.0304 C99.8452303,29.0304 103.358264,31.0743707 105.16793,34.0206702 C105.326718,34.3057538 105.486819,34.5424516 105.593116,34.8275352 C105.753217,35.1139265 105.859513,35.39901 105.96581,35.7311716 C106.284699,36.6335004 106.4448,37.5842148 106.4448,38.5349293 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-7\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linejoin=\"round\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M0,40.0640948 C0,36.7352797 1.49077574,33.3516528 4.52350703,31.0428721 L4.84239656,30.8289724 L45.658944,2.38030335 C50.2113217,-0.793434449 56.2334783,-0.793434449 60.785856,2.38030335 L101.601091,30.8289724 L101.921293,31.0428721 C104.954024,33.3516528 106.4448,36.7352797 106.4448,40.0640948 C106.4448,41.1376043 106.284699,42.2124506 105.96581,43.2324851 C105.859513,43.6081466 105.753217,43.9303331 105.593116,44.2525196 C105.486819,44.5747062 105.326718,44.8434177 105.16793,45.1656043 C103.356952,48.4944194 99.8452303,50.8032 95.8007137,50.8032 L10.6440863,50.8032 C6.59956973,50.8032 3.08653569,48.4944194 1.27687042,45.1656043 C1.11808181,44.8434177 0.957980891,44.5747062 0.851684381,44.2525196 C0.691583465,43.9303331 0.585286955,43.6081466 0.478990445,43.2324851 C0.160100916,42.2124506 0,41.1376043 0,40.0640948\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-9\" fill=\"#9DD2FF\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M0,40.0640948 C0,36.7352797 1.49077574,33.3516528 4.52350703,31.0428721 L4.84239656,30.8289724 L45.658944,2.38030335 C50.2113217,-0.793434449 56.2334783,-0.793434449 60.785856,2.38030335 L101.601091,30.8289724 L101.921293,31.0428721 C104.954024,33.3516528 106.4448,36.7352797 106.4448,40.0640948 C106.4448,41.1376043 106.284699,42.2124506 105.96581,43.2324851 C105.859513,43.6081466 105.753217,43.9303331 105.593116,44.2525196 C105.486819,44.5747062 105.326718,44.8434177 105.16793,45.1656043 C103.356952,48.4944194 99.8452303,50.8032 95.8007137,50.8032 L10.6440863,50.8032 C6.59956973,50.8032 3.08653569,48.4944194 1.27687042,45.1656043 C1.11808181,44.8434177 0.957980891,44.5747062 0.851684381,44.2525196 C0.691583465,43.9303331 0.585286955,43.6081466 0.478990445,43.2324851 C0.160100916,42.2124506 0,41.1376043 0,40.0640948 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-11\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linejoin=\"round\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M91.9296,50.8032 L91.9296,8.98629601 C91.9296,8.03092904 90.7188472,7.2576 89.223443,7.2576 L14.802157,7.2576 C13.3067528,7.2576 12.096,8.03092904 12.096,8.98629601 L12.096,50.8032 L91.9296,50.8032 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-13\" fill=\"#FFFFFF\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M91.9296,50.8032 L91.9296,8.98629601 C91.9296,8.03092904 90.7188472,7.2576 89.223443,7.2576 L14.802157,7.2576 C13.3067528,7.2576 12.096,8.03092904 12.096,8.98629601 L12.096,50.8032 L91.9296,50.8032 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-15\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linecap=\"round\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-17\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 19.3536 84.672 19.3536 84.672 16.9344 21.7728 16.9344\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-19\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 24.192 67.7376 24.192 67.7376 21.7728 21.7728 21.7728\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-20\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 36.288 84.672 36.288 84.672 33.8688 21.7728 33.8688\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-21\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 43.5456 67.7376 43.5456 67.7376 41.1264 21.7728 41.1264\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t\t\t<g id=\"Group-5-Copy\" transform=\"translate(67.200000, 58.800000)\">\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M57.257088,28.628544 C57.257088,44.43936 44.43936,57.257088 28.628544,57.257088 C12.817728,57.257088 5.72981662e-14,44.43936 5.72981662e-14,28.628544 C5.72981662e-14,12.817728 12.817728,5.72981662e-14 28.628544,5.72981662e-14 C44.43936,5.72981662e-14 57.257088,12.817728 57.257088,28.628544\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-22\" fill=\"#4AA740\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M57.257088,28.628544 C57.257088,44.43936 44.43936,57.257088 28.628544,57.257088 C12.817728,57.257088 5.72981662e-14,44.43936 5.72981662e-14,28.628544 C5.72981662e-14,12.817728 12.817728,5.72981662e-14 28.628544,5.72981662e-14 C44.43936,5.72981662e-14 57.257088,12.817728 57.257088,28.628544 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-23\" stroke=\"#0033AA\" stroke-width=\"1.344\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<polyline id=\"Stroke-24\" stroke=\"#FFFFFF\" stroke-width=\"2.688\" stroke-linecap=\"round\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"15.067584 30.1353024 24.108672 39.1763904 42.189504 18.0809664\"></polyline>\n\t\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t</i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</form>";
        }
        var preview = this.element.querySelector('.form-builder__preview');
        preview.innerHTML = '';
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(content));
        preview.appendChild(docfragment);
        output.value = content;
    };
    //////////////////////////////////////
    //////////////////////////////////////
    // GENERIC FORM - BUILD LAYOUT BASED ON JSON
    //////////////////////////////////////
    //////////////////////////////////////
    FormBuilder.prototype.buildJSON = function (event) {
        var _this = this;
        this.containerFieldsComponents.innerHTML = '';
        var element = undefined;
        element = event.target;
        if (element.value) {
            var json = JSON.parse(element.value);
            json.forEach(function (field) {
                if (field.type) {
                    switch (field.type) {
                        case 'heading':
                            _this.addFieldHeading(field);
                            break;
                        case 'paragraph':
                            _this.addFieldParagraph(field);
                            break;
                        case 'input':
                            _this.addFieldInput(field);
                            break;
                        case 'number':
                            _this.addFieldInputNumber(field);
                            break;
                        case 'email':
                            _this.addFieldInputEmail(field);
                            break;
                        case 'textarea':
                            _this.addFieldTextarea(field);
                            break;
                        case 'date':
                            _this.addFieldDate(field);
                            break;
                        case 'dropdown':
                            _this.addFieldDropdown(field);
                            break;
                        case 'icontext':
                            _this.addFieldIconText(field);
                            break;
                        case 'checkbox':
                            _this.addFieldCheckbox(field);
                            break;
                        case 'radio':
                            _this.addFieldRadio(field);
                            break;
                        case 'passport':
                            _this.addFieldIdPassport(field);
                            break;
                        case 'countries':
                            _this.addFieldCountries(field);
                            break;
                        case 'provinces':
                            _this.addFieldProvinces(field);
                            break;
                        case 'form-name':
                            if (_this.inputFormHeading) {
                                _this.inputFormHeading.value = field.value;
                            }
                            break;
                        case 'form-analytics':
                            if (_this.inputFormAnalytics) {
                                _this.inputFormAnalytics.value = field.value;
                            }
                            break;
                        case 'form-recipient':
                            if (_this.inputFormRecipient) {
                                _this.inputFormRecipient.value = field.value;
                            }
                            break;
                        case 'form-email':
                            if (_this.inputFormEmail) {
                                _this.inputFormEmail.value = field.value;
                            }
                            break;
                        case 'form-subject':
                            if (_this.inputFormSubject) {
                                _this.inputFormSubject.value = field.value;
                            }
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    };
    //////////////////////////////////////
    //////////////////////////////////////
    // GENERIC FORM - ADDING FIELD
    //////////////////////////////////////
    //////////////////////////////////////
    FormBuilder.prototype.addFieldHeading = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"heading\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype inactive\">Heading</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">Your Heading</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Text</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-heading-text\" value=\"Your Heading\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldText = docfragment.querySelector('.js-heading-text');
        if (json.value) {
            fieldText.value = json.value;
            heading.innerHTML = json.value;
        }
        fieldText.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        this.inputFocus(fieldText);
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldParagraph = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"paragraph\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype inactive\">Paragraph</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">Paragraphs can be used as introductions or help explain why we need further information</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Text</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-paragraph-text\" value=\"Paragraphs can be used as introductions or help explain why we need further information\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldText = docfragment.querySelector('.js-paragraph-text');
        fieldText.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        if (json.value) {
            fieldText.value = json.value;
            heading.innerHTML = json.value;
        }
        this.inputFocus(fieldText);
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldInput = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"input\" data-index=\"133005598\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype\">Textfield</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">Your Text field</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Column</label>\n\t\t\t\t\t<select class=\"form__input js-column-value\">\n\t\t\t\t\t\t<option value=\"col-md-12\">Fullwidth</option>\n\t\t\t\t\t\t<option value=\"col-md-6\">Half</option>\n\t\t\t\t\t\t<option value=\"col-md-4\">Third</option>\n\t\t\t\t\t\t<option value=\"col-md-8\">Two Thirds</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<label class=\"form__label\">Label</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-label-text\" value=\"Your Text field\">\n\t\t\t\t\t<label class=\"form__label\">Field Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-name-text\" value=\"field_name\">\n\t\t\t\t\t<label class=\"form__label form-builder__guideline\">Placeholder <span>(Guideline for input text)</span></label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-placeholder-text\" value=\"e.g. Please Complete\">\n\t\t\t\t\t<label class=\"form__label\">Required</label>\n\t\t\t\t\t<div class=\"form__group\">\n\t\t\t\t\t\t<label class=\"form__control form__control--checkbox\">Required\n\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"js-required-field\">\n\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-builder__container--field__name\">field_name</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        //// container
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        //// remove button
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        //// select column
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        var fieldColumn = docfragment.querySelector('.js-column-value');
        var fieldOptions = Array.from(fieldColumn.querySelectorAll('option'));
        if (fieldOptions) {
            fieldOptions.forEach(function (option) {
                var value = option.getAttribute('value');
                if (json.column) {
                    if (json.column === value) {
                        option.setAttribute('selected', 'true');
                    }
                }
            });
        }
        fieldColumn.addEventListener('change', function (e) {
            _this.buildPreview();
        });
        this.inputFocus(fieldColumn);
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        //// input label
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        var fieldLabel = docfragment.querySelector('.js-label-text');
        if (json.label) {
            fieldLabel.value = json.label;
            heading.innerHTML = json.label;
        }
        fieldLabel.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        this.inputFocus(fieldLabel);
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        //// input name
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        var fieldName = docfragment.querySelector('.js-name-text');
        var labelName = docfragment.querySelector('.form-builder__container--field__name');
        if (json.name) {
            fieldName.value = json.name;
            labelName.innerHTML = json.name;
        }
        fieldName.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            var value = element.value;
            element.setAttribute('value', value);
            labelName.innerHTML = value;
            _this.buildPreview();
        });
        this.inputFocus(fieldName);
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        //// input placeholder
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        var fieldPlaceholder = docfragment.querySelector('.js-placeholder-text');
        if (json.placeholder) {
            fieldPlaceholder.value = json.placeholder;
        }
        fieldPlaceholder.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            _this.buildPreview();
        });
        this.inputFocus(fieldPlaceholder);
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        //// checkbox required
        ////////////////////////////////////////////
        ////////////////////////////////////////////
        var fieldRequired = docfragment.querySelector('.js-required-field');
        fieldRequired.addEventListener('click', function (e) {
            if (fieldRequired.getAttribute('checked')) {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
            else {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            _this.buildPreview();
        });
        if (json.required) {
            if (json.required === true) {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            else {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
        }
        this.inputFocus(fieldRequired);
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldInputNumber = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"number\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype\">Number</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">Number</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Column</label>\n\t\t\t\t\t<select class=\"form__input js-column-value\">\n\t\t\t\t\t\t<option value=\"col-md-12\">Fullwidth</option>\n\t\t\t\t\t\t<option value=\"col-md-6\">Half</option>\n\t\t\t\t\t\t<option value=\"col-md-4\">Third</option>\n\t\t\t\t\t\t<option value=\"col-md-8\">Two Thirds</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<label class=\"form__label\">Label</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-label-text\" value=\"Number\">\n\t\t\t\t\t<label class=\"form__label\">Field Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-name-text\" value=\"field_name\">\n\t\t\t\t\t<label class=\"form__label\">Placeholder <span>(Guideline for input text)</span></label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-placeholder-text\" value=\"e.g. +27 11 444 4444 or XXX\">\n\t\t\t\t\t<label class=\"form__label\">Required</label>\n\t\t\t\t\t<div class=\"form__group\">\n\t\t\t\t\t\t<label class=\"form__control form__control--checkbox\">Required\n\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"js-required-field\">\n\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-builder__container--field__name\">field_name</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldColumn = docfragment.querySelector('.js-column-value');
        var fieldOptions = Array.from(fieldColumn.querySelectorAll('option'));
        if (fieldOptions) {
            fieldOptions.forEach(function (option) {
                var value = option.getAttribute('value');
                if (json.column) {
                    if (json.column === value) {
                        option.setAttribute('selected', 'true');
                    }
                }
            });
        }
        fieldColumn.addEventListener('change', function (e) {
            _this.buildPreview();
        });
        this.inputFocus(fieldColumn);
        var fieldLabel = docfragment.querySelector('.js-label-text');
        if (json.label) {
            fieldLabel.value = json.label;
            heading.innerHTML = json.label;
        }
        fieldLabel.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        this.inputFocus(fieldLabel);
        var fieldName = docfragment.querySelector('.js-name-text');
        var labelName = docfragment.querySelector('.form-builder__container--field__name');
        if (json.name) {
            fieldName.value = json.name;
            labelName.innerHTML = json.name;
        }
        fieldName.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            var value = element.value;
            element.setAttribute('value', value);
            labelName.innerHTML = value;
            _this.buildPreview();
        });
        this.inputFocus(fieldName);
        var fieldPlaceholder = docfragment.querySelector('.js-placeholder-text');
        if (json.placeholder) {
            fieldPlaceholder.value = json.placeholder;
        }
        fieldPlaceholder.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            _this.buildPreview();
        });
        this.inputFocus(fieldPlaceholder);
        var fieldRequired = docfragment.querySelector('.js-required-field');
        fieldRequired.addEventListener('click', function (e) {
            if (fieldRequired.getAttribute('checked')) {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
            else {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            _this.buildPreview();
        });
        if (json.required) {
            if (json.required === true) {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            else {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
        }
        this.inputFocus(fieldRequired);
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldInputEmail = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"email\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype\">Email</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">E-mail address</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Column</label>\n\t\t\t\t\t<select class=\"form__input js-column-value\">\n\t\t\t\t\t\t<option value=\"col-md-12\">Fullwidth</option>\n\t\t\t\t\t\t<option value=\"col-md-6\">Half</option>\n\t\t\t\t\t\t<option value=\"col-md-4\">Third</option>\n\t\t\t\t\t\t<option value=\"col-md-8\">Two Thirds</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<label class=\"form__label\">Label</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-label-text\" value=\"E-mail address\">\n\t\t\t\t\t<label class=\"form__label\">Field Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-name-text\" value=\"field_name\">\n\t\t\t\t\t<label class=\"form__label\">Placeholder <span>(Guideline for input text)</span></label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-placeholder-text\" value=\"somebody@company.com\">\n\t\t\t\t\t<label class=\"form__label\">Required</label>\n\t\t\t\t\t<div class=\"form__group\">\n\t\t\t\t\t\t<label class=\"form__control form__control--checkbox\">Required\n\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"js-required-field\">\n\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-builder__container--field__name\">field_name</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldColumn = docfragment.querySelector('.js-column-value');
        var fieldOptions = Array.from(fieldColumn.querySelectorAll('option'));
        if (fieldOptions) {
            fieldOptions.forEach(function (option) {
                var value = option.getAttribute('value');
                if (json.column) {
                    if (json.column === value) {
                        option.setAttribute('selected', 'true');
                    }
                }
            });
        }
        fieldColumn.addEventListener('change', function (e) {
            _this.buildPreview();
        });
        this.inputFocus(fieldColumn);
        var fieldLabel = docfragment.querySelector('.js-label-text');
        if (json.label) {
            fieldLabel.value = json.label;
            heading.innerHTML = json.label;
        }
        fieldLabel.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        this.inputFocus(fieldLabel);
        var fieldName = docfragment.querySelector('.js-name-text');
        var labelName = docfragment.querySelector('.form-builder__container--field__name');
        if (json.name) {
            fieldName.value = json.name;
            labelName.innerHTML = json.name;
        }
        fieldName.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            var value = element.value;
            element.setAttribute('value', value);
            labelName.innerHTML = value;
            _this.buildPreview();
        });
        this.inputFocus(fieldName);
        var fieldPlaceholder = docfragment.querySelector('.js-placeholder-text');
        if (json.placeholder) {
            fieldPlaceholder.value = json.placeholder;
        }
        fieldPlaceholder.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            _this.buildPreview();
        });
        this.inputFocus(fieldPlaceholder);
        var fieldRequired = docfragment.querySelector('.js-required-field');
        fieldRequired.addEventListener('click', function (e) {
            if (fieldRequired.getAttribute('checked')) {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
            else {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            _this.buildPreview();
        });
        if (json.required) {
            if (json.required === true) {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            else {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
        }
        this.inputFocus(fieldRequired);
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldTextarea = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"textarea\" data-index=\"133005598\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype\">Textarea</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">Text Area (For detailed responses)</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Column</label>\n\t\t\t\t\t<select class=\"form__input js-column-value\">\n\t\t\t\t\t\t<option value=\"col-md-12\">Fullwidth</option>\n\t\t\t\t\t\t<option value=\"col-md-6\">Half</option>\n\t\t\t\t\t\t<option value=\"col-md-4\">Third</option>\n\t\t\t\t\t\t<option value=\"col-md-8\">Two Thirds</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<label class=\"form__label\">Label</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-label-text\" value=\"Text Area (For detailed responses)\">\n\t\t\t\t\t<label class=\"form__label\">Field Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-name-text\" value=\"field_name\">\n\t\t\t\t\t<label class=\"form__label\">Placeholder <span>(Guideline for input text)</span></label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-placeholder-text\" value=\"Please tell us more...\">\n\t\t\t\t\t<label class=\"form__label\">Required</label>\n\t\t\t\t\t<div class=\"form__group\">\n\t\t\t\t\t\t<label class=\"form__control form__control--checkbox\">Required\n\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"js-required-field\">\n\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-builder__container--field__name\">field_name</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldColumn = docfragment.querySelector('.js-column-value');
        var fieldOptions = Array.from(fieldColumn.querySelectorAll('option'));
        if (fieldOptions) {
            fieldOptions.forEach(function (option) {
                var value = option.getAttribute('value');
                if (json.column) {
                    if (json.column === value) {
                        option.setAttribute('selected', 'true');
                    }
                }
            });
        }
        fieldColumn.addEventListener('change', function (e) {
            _this.buildPreview();
        });
        this.inputFocus(fieldColumn);
        var fieldLabel = docfragment.querySelector('.js-label-text');
        if (json.label) {
            fieldLabel.value = json.label;
            heading.innerHTML = json.label;
        }
        fieldLabel.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        this.inputFocus(fieldLabel);
        var fieldName = docfragment.querySelector('.js-name-text');
        var labelName = docfragment.querySelector('.form-builder__container--field__name');
        if (json.name) {
            fieldName.value = json.name;
            labelName.innerHTML = json.name;
        }
        fieldName.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            var value = element.value;
            element.setAttribute('value', value);
            labelName.innerHTML = value;
            _this.buildPreview();
        });
        this.inputFocus(fieldName);
        var fieldPlaceholder = docfragment.querySelector('.js-placeholder-text');
        if (json.placeholder) {
            fieldPlaceholder.value = json.placeholder;
        }
        fieldPlaceholder.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            _this.buildPreview();
        });
        this.inputFocus(fieldPlaceholder);
        var fieldRequired = docfragment.querySelector('.js-required-field');
        fieldRequired.addEventListener('click', function (e) {
            if (fieldRequired.getAttribute('checked')) {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
            else {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            _this.buildPreview();
        });
        if (json.required) {
            if (json.required === true) {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            else {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
        }
        this.inputFocus(fieldRequired);
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldDate = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"date\" data-index=\"133005598\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype\">Date</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">Date</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Column</label>\n\t\t\t\t\t<select class=\"form__input js-column-value\">\n\t\t\t\t\t\t<option value=\"col-md-12\">Fullwidth</option>\n\t\t\t\t\t\t<option value=\"col-md-6\">Half</option>\n\t\t\t\t\t\t<option value=\"col-md-4\">Third</option>\n\t\t\t\t\t\t<option value=\"col-md-8\">Two Thirds</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<label class=\"form__label\">Label</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-label-text\" value=\"Date\">\n\t\t\t\t\t<label class=\"form__label\">Field Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-name-text\" value=\"field_name\">\n\t\t\t\t\t<label class=\"form__label\">Placeholder <span>(Guideline for input text)</span></label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-placeholder-text\" value=\"2020/01/01\">\n\t\t\t\t\t<label class=\"form__label\">Required</label>\n\t\t\t\t\t<div class=\"form__group\">\n\t\t\t\t\t\t<label class=\"form__control form__control--checkbox\">Required\n\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"js-required-field\">\n\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-builder__container--field__name\">field_name</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldColumn = docfragment.querySelector('.js-column-value');
        var fieldOptions = Array.from(fieldColumn.querySelectorAll('option'));
        if (fieldOptions) {
            fieldOptions.forEach(function (option) {
                var value = option.getAttribute('value');
                if (json.column) {
                    if (json.column === value) {
                        option.setAttribute('selected', 'true');
                    }
                }
            });
        }
        fieldColumn.addEventListener('change', function (e) {
            _this.buildPreview();
        });
        this.inputFocus(fieldColumn);
        var fieldLabel = docfragment.querySelector('.js-label-text');
        if (json.label) {
            fieldLabel.value = json.label;
            heading.innerHTML = json.label;
        }
        fieldLabel.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        this.inputFocus(fieldLabel);
        var fieldName = docfragment.querySelector('.js-name-text');
        var labelName = docfragment.querySelector('.form-builder__container--field__name');
        if (json.name) {
            fieldName.value = json.name;
            labelName.innerHTML = json.name;
        }
        fieldName.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            var value = element.value;
            element.setAttribute('value', value);
            labelName.innerHTML = value;
            _this.buildPreview();
        });
        this.inputFocus(fieldName);
        var fieldPlaceholder = docfragment.querySelector('.js-placeholder-text');
        if (json.placeholder) {
            fieldPlaceholder.value = json.placeholder;
        }
        fieldPlaceholder.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            _this.buildPreview();
        });
        this.inputFocus(fieldPlaceholder);
        var fieldRequired = docfragment.querySelector('.js-required-field');
        fieldRequired.addEventListener('click', function (e) {
            if (fieldRequired.getAttribute('checked')) {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
            else {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            _this.buildPreview();
        });
        if (json.required) {
            if (json.required === true) {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            else {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
        }
        this.inputFocus(fieldRequired);
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldDropdown = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"dropdown\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype\">Dropdown</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">Choose an Option</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Column</label>\n\t\t\t\t\t<select class=\"form__input js-column-value\">\n\t\t\t\t\t\t<option value=\"col-md-12\">Fullwidth</option>\n\t\t\t\t\t\t<option value=\"col-md-6\">Half</option>\n\t\t\t\t\t\t<option value=\"col-md-4\">Third</option>\n\t\t\t\t\t\t<option value=\"col-md-8\">Two Thirds</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<label class=\"form__label\">Label</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-label-text\" value=\"Choose an Option\">\n\t\t\t\t\t<label class=\"form__label\">Field Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-name-text\" value=\"field_name\">\n\t\t\t\t\t<label class=\"form__label\">Options</label>\n\t\t\t\t\t<div class=\"form-builder__options\"></div>\n\t\t\t\t\t<div class=\"form__group text-center\">\n\t\t\t\t\t\t<div class=\"button button--white button--border-blue button--small js-new-option\" style=\"margin-botom: 10px; display: inline-block;\">Add Option</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<label class=\"form__label\">Required</label>\n\t\t\t\t\t<div class=\"form__group\">\n\t\t\t\t\t\t<label class=\"form__control form__control--checkbox\">Required\n\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"js-required-field\">\n\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-builder__container--field__name\">field_name</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldColumn = docfragment.querySelector('.js-column-value');
        var fieldOptions = Array.from(fieldColumn.querySelectorAll('option'));
        if (fieldOptions) {
            fieldOptions.forEach(function (option) {
                var value = option.getAttribute('value');
                if (json.column) {
                    if (json.column === value) {
                        option.setAttribute('selected', 'true');
                    }
                }
            });
        }
        fieldColumn.addEventListener('change', function (e) {
            _this.buildPreview();
        });
        this.inputFocus(fieldColumn);
        var fieldLabel = docfragment.querySelector('.js-label-text');
        if (json.label) {
            fieldLabel.value = json.label;
            heading.innerHTML = json.label;
        }
        fieldLabel.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        this.inputFocus(fieldLabel);
        var fieldName = docfragment.querySelector('.js-name-text');
        var labelName = docfragment.querySelector('.form-builder__container--field__name');
        if (json.name) {
            fieldName.value = json.name;
            labelName.innerHTML = json.name;
        }
        fieldName.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            var value = element.value;
            element.setAttribute('value', value);
            labelName.innerHTML = value;
            _this.buildPreview();
        });
        this.inputFocus(fieldName);
        var containerOptions = docfragment.querySelector('.form-builder__options');
        var addOptionButton = docfragment.querySelector('.js-new-option');
        addOptionButton.addEventListener('click', function (e) {
            var option = "<div class=\"form-builder__options--option ui-kit__palette--shadow\">\n\t\t\t\t<div class=\"form-builder__options--option__remove\">Remove</div>\n\t\t\t\t<label class=\"form__label\">Text</label>\n\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-text\">\n\t\t\t\t<label class=\"form__label\">Value</label>\n\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-value\">\n\t\t\t</div>";
            var docfragmentOption = document.createDocumentFragment();
            docfragmentOption.appendChild(document.createRange().createContextualFragment(option));
            var removeButtonOption = docfragmentOption.querySelector('.form-builder__options--option__remove');
            removeButtonOption.addEventListener('click', function (e) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var parentContainer = element.closest('.form-builder__options--option');
                containerOptions.removeChild(parentContainer);
            });
            var optionText = docfragmentOption.querySelector('.js-option-text');
            optionText.addEventListener('keyup', function (e) {
                var element = undefined;
                element = e.target;
                element.setAttribute('value', element.value);
                _this.buildPreview();
            });
            var optionValue = docfragmentOption.querySelector('.js-option-value');
            optionValue.addEventListener('keyup', function (e) {
                var element = undefined;
                element = e.target;
                element.setAttribute('value', element.value);
                _this.buildPreview();
            });
            containerOptions.appendChild(docfragmentOption);
        });
        if (json.options) {
            json.options.forEach(function (item) {
                var option = "<div class=\"form-builder__options--option ui-kit__palette--shadow\">\n\t\t\t\t\t<div class=\"form-builder__options--option__remove\">Remove</div>\n\t\t\t\t\t<label class=\"form__label\">Text</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-text\">\n\t\t\t\t\t<label class=\"form__label\">Value</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-value\">\n\t\t\t\t</div>";
                var docfragmentOption = document.createDocumentFragment();
                docfragmentOption.appendChild(document.createRange().createContextualFragment(option));
                var removeButtonOption = docfragmentOption.querySelector('.form-builder__options--option__remove');
                removeButtonOption.addEventListener('click', function (e) {
                    var element = undefined;
                    if (event.currentTarget) {
                        element = event.currentTarget;
                    }
                    else {
                        element = event.target;
                    }
                    var parentContainer = element.closest('.form-builder__options--option');
                    containerOptions.removeChild(parentContainer);
                });
                var optionText = docfragmentOption.querySelector('.js-option-text');
                if (item.name) {
                    optionText.value = item.name;
                }
                optionText.addEventListener('keyup', function (e) {
                    var element = undefined;
                    element = e.target;
                    element.setAttribute('value', element.value);
                    _this.buildPreview();
                });
                _this.inputFocus(optionText);
                var optionValue = docfragmentOption.querySelector('.js-option-value');
                if (item.value) {
                    optionValue.value = item.value;
                }
                optionValue.addEventListener('keyup', function (e) {
                    var element = undefined;
                    element = e.target;
                    element.setAttribute('value', element.value);
                    _this.buildPreview();
                });
                _this.inputFocus(optionValue);
                containerOptions.appendChild(docfragmentOption);
            });
        }
        else {
            var defaultOptions = [
                {
                    name: 'Item 1',
                    value: 'Item 1',
                },
                {
                    name: 'Item 2',
                    value: 'Item 2',
                },
                {
                    name: 'Item 3',
                    value: 'Item 3',
                }
            ];
            if (defaultOptions) {
                defaultOptions.forEach(function (item) {
                    var option = "<div class=\"form-builder__options--option ui-kit__palette--shadow\">\n\t\t\t\t\t\t<div class=\"form-builder__options--option__remove\">Remove</div>\n\t\t\t\t\t\t<label class=\"form__label\">Text</label>\n\t\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-text\">\n\t\t\t\t\t\t<label class=\"form__label\">Value</label>\n\t\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-value\">\n\t\t\t\t\t</div>";
                    var docfragmentOption = document.createDocumentFragment();
                    docfragmentOption.appendChild(document.createRange().createContextualFragment(option));
                    var removeButtonOption = docfragmentOption.querySelector('.form-builder__options--option__remove');
                    removeButtonOption.addEventListener('click', function (e) {
                        var element = undefined;
                        if (event.currentTarget) {
                            element = event.currentTarget;
                        }
                        else {
                            element = event.target;
                        }
                        var parentContainer = element.closest('.form-builder__options--option');
                        containerOptions.removeChild(parentContainer);
                        _this.buildPreview();
                    });
                    var optionText = docfragmentOption.querySelector('.js-option-text');
                    if (item.name) {
                        optionText.value = item.name;
                    }
                    optionText.addEventListener('keyup', function (e) {
                        var element = undefined;
                        element = e.target;
                        element.setAttribute('value', element.value);
                        _this.buildPreview();
                    });
                    _this.inputFocus(optionText);
                    var optionValue = docfragmentOption.querySelector('.js-option-value');
                    if (item.value) {
                        optionValue.value = item.value;
                    }
                    optionValue.addEventListener('keyup', function (e) {
                        var element = undefined;
                        element = e.target;
                        element.setAttribute('value', element.value);
                        _this.buildPreview();
                    });
                    _this.inputFocus(optionValue);
                    containerOptions.appendChild(docfragmentOption);
                });
            }
        }
        var fieldRequired = docfragment.querySelector('.js-required-field');
        fieldRequired.addEventListener('click', function (e) {
            if (fieldRequired.getAttribute('checked')) {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
            else {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            _this.buildPreview();
        });
        if (json.required) {
            if (json.required === true) {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            else {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
        }
        this.inputFocus(fieldRequired);
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldIconText = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"icontext\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype inactive\">Icon / Text</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">Your information will be managed securely</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Icon</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-icon-value\" value=\"<img src='/file_source/assets/icons/icon-lock.svg'>\">\n\t\t\t\t\t<label class=\"form__label\">Text</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-text-value\" value=\"Your information will be managed securely\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldIcon = docfragment.querySelector('.js-icon-value');
        if (json.icon) {
            fieldIcon.value = json.name;
        }
        fieldIcon.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            _this.buildPreview();
        });
        this.inputFocus(fieldIcon);
        var fieldText = docfragment.querySelector('.js-text-value');
        if (json.text) {
            fieldText.value = json.text;
            heading.innerHTML = json.text;
        }
        fieldText.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        this.inputFocus(fieldText);
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldCheckbox = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"checkbox\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype\">Checkbox</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">Which option would you like?</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Column</label>\n\t\t\t\t\t<select class=\"form__input js-column-value\">\n\t\t\t\t\t\t<option value=\"col-md-12\">Fullwidth</option>\n\t\t\t\t\t\t<option value=\"col-md-6\">Half</option>\n\t\t\t\t\t\t<option value=\"col-md-4\">Third</option>\n\t\t\t\t\t\t<option value=\"col-md-8\">Two Thirds</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<label class=\"form__label\">Label</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-label-text\" value=\"Which option would you like?\">\n\t\t\t\t\t<label class=\"form__label\">Field Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-name-text\" value=\"field_name\">\n\t\t\t\t\t<label class=\"form__label\">Options</label>\n\t\t\t\t\t<div class=\"form-builder__options\"></div>\n\t\t\t\t\t<div class=\"form__group text-center\">\n\t\t\t\t\t\t<div class=\"button button--white button--border-blue button--small js-new-option\" style=\"margin-botom: 10px; display: inline-block;\">Add Option</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-builder__container--field__name\">field_name</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldColumn = docfragment.querySelector('.js-column-value');
        var fieldOptions = Array.from(fieldColumn.querySelectorAll('option'));
        if (fieldOptions) {
            fieldOptions.forEach(function (option) {
                var value = option.getAttribute('value');
                if (json.column) {
                    if (json.column === value) {
                        option.setAttribute('selected', 'true');
                    }
                }
            });
        }
        fieldColumn.addEventListener('change', function (e) {
            _this.buildPreview();
        });
        this.inputFocus(fieldColumn);
        var fieldLabel = docfragment.querySelector('.js-label-text');
        if (json.label) {
            fieldLabel.value = json.label;
            heading.innerHTML = json.label;
        }
        fieldLabel.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        this.inputFocus(fieldLabel);
        var fieldName = docfragment.querySelector('.js-name-text');
        var labelName = docfragment.querySelector('.form-builder__container--field__name');
        if (json.name) {
            fieldName.value = json.name;
            labelName.innerHTML = json.name;
        }
        fieldName.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            var value = element.value;
            element.setAttribute('value', value);
            labelName.innerHTML = value;
            _this.buildPreview();
        });
        this.inputFocus(fieldName);
        var containerOptions = docfragment.querySelector('.form-builder__options');
        var addOptionButton = docfragment.querySelector('.js-new-option');
        addOptionButton.addEventListener('click', function (e) {
            var option = "<div class=\"form-builder__options--option ui-kit__palette--shadow\">\n\t\t\t\t<div class=\"form-builder__options--option__remove\">Remove</div>\n\t\t\t\t<label class=\"form__label\">Text</label>\n\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-text\">\n\t\t\t\t<label class=\"form__label\">Value</label>\n\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-value\">\n\t\t\t</div>";
            var docfragmentOption = document.createDocumentFragment();
            docfragmentOption.appendChild(document.createRange().createContextualFragment(option));
            var removeButtonOption = docfragmentOption.querySelector('.form-builder__options--option__remove');
            removeButtonOption.addEventListener('click', function (e) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var parentContainer = element.closest('.form-builder__options--option');
                containerOptions.removeChild(parentContainer);
            });
            var optionText = docfragmentOption.querySelector('.js-option-text');
            optionText.addEventListener('keyup', function (e) {
                var element = undefined;
                element = e.target;
                element.setAttribute('value', element.value);
                _this.buildPreview();
            });
            _this.inputFocus(optionText);
            var optionValue = docfragmentOption.querySelector('.js-option-value');
            optionValue.addEventListener('keyup', function (e) {
                var element = undefined;
                element = e.target;
                element.setAttribute('value', element.value);
                _this.buildPreview();
            });
            _this.inputFocus(optionValue);
            containerOptions.appendChild(docfragmentOption);
        });
        if (json.options) {
            json.options.forEach(function (item) {
                var option = "<div class=\"form-builder__options--option ui-kit__palette--shadow\">\n\t\t\t\t\t<div class=\"form-builder__options--option__remove\">Remove</div>\n\t\t\t\t\t<label class=\"form__label\">Text</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-text\">\n\t\t\t\t\t<label class=\"form__label\">Value</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-value\">\n\t\t\t\t</div>";
                var docfragmentOption = document.createDocumentFragment();
                docfragmentOption.appendChild(document.createRange().createContextualFragment(option));
                var removeButtonOption = docfragmentOption.querySelector('.form-builder__options--option__remove');
                removeButtonOption.addEventListener('click', function (e) {
                    var element = undefined;
                    if (event.currentTarget) {
                        element = event.currentTarget;
                    }
                    else {
                        element = event.target;
                    }
                    var parentContainer = element.closest('.form-builder__options--option');
                    containerOptions.removeChild(parentContainer);
                });
                var optionText = docfragmentOption.querySelector('.js-option-text');
                if (item.name) {
                    optionText.value = item.name;
                }
                optionText.addEventListener('keyup', function (e) {
                    var element = undefined;
                    element = e.target;
                    element.setAttribute('value', element.value);
                    _this.buildPreview();
                });
                _this.inputFocus(optionText);
                var optionValue = docfragmentOption.querySelector('.js-option-value');
                if (item.value) {
                    optionValue.value = item.value;
                }
                optionValue.addEventListener('keyup', function (e) {
                    var element = undefined;
                    element = e.target;
                    element.setAttribute('value', element.value);
                    _this.buildPreview();
                });
                _this.inputFocus(optionValue);
                containerOptions.appendChild(docfragmentOption);
            });
        }
        else {
            var defaultOptions = [
                {
                    name: 'Item 1',
                    value: 'Item 1',
                },
                {
                    name: 'Item 2',
                    value: 'Item 2',
                },
                {
                    name: 'Item 3',
                    value: 'Item 3',
                }
            ];
            if (defaultOptions) {
                defaultOptions.forEach(function (item) {
                    var option = "<div class=\"form-builder__options--option ui-kit__palette--shadow\">\n\t\t\t\t\t\t<div class=\"form-builder__options--option__remove\">Remove</div>\n\t\t\t\t\t\t<label class=\"form__label\">Text</label>\n\t\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-text\">\n\t\t\t\t\t\t<label class=\"form__label\">Value</label>\n\t\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-value\">\n\t\t\t\t\t</div>";
                    var docfragmentOption = document.createDocumentFragment();
                    docfragmentOption.appendChild(document.createRange().createContextualFragment(option));
                    var removeButtonOption = docfragmentOption.querySelector('.form-builder__options--option__remove');
                    removeButtonOption.addEventListener('click', function (e) {
                        var element = undefined;
                        if (event.currentTarget) {
                            element = event.currentTarget;
                        }
                        else {
                            element = event.target;
                        }
                        var parentContainer = element.closest('.form-builder__options--option');
                        containerOptions.removeChild(parentContainer);
                        _this.buildPreview();
                    });
                    var optionText = docfragmentOption.querySelector('.js-option-text');
                    if (item.name) {
                        optionText.value = item.name;
                    }
                    optionText.addEventListener('keyup', function (e) {
                        var element = undefined;
                        element = e.target;
                        element.setAttribute('value', element.value);
                        _this.buildPreview();
                    });
                    _this.inputFocus(optionText);
                    var optionValue = docfragmentOption.querySelector('.js-option-value');
                    if (item.value) {
                        optionValue.value = item.value;
                    }
                    optionValue.addEventListener('keyup', function (e) {
                        var element = undefined;
                        element = e.target;
                        element.setAttribute('value', element.value);
                        _this.buildPreview();
                    });
                    _this.inputFocus(optionValue);
                    containerOptions.appendChild(docfragmentOption);
                });
            }
        }
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldRadio = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"radio\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype\">Radio Buttons</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">Choose one of the following</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Column</label>\n\t\t\t\t\t<select class=\"form__input js-column-value\">\n\t\t\t\t\t\t<option value=\"col-md-12\">Fullwidth</option>\n\t\t\t\t\t\t<option value=\"col-md-6\">Half</option>\n\t\t\t\t\t\t<option value=\"col-md-4\">Third</option>\n\t\t\t\t\t\t<option value=\"col-md-8\">Two Thirds</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<label class=\"form__label\">Label</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-label-text\" value=\"Choose one of the following\">\n\t\t\t\t\t<label class=\"form__label\">Field Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-name-text\" value=\"field_name\">\n\t\t\t\t\t<label class=\"form__label\">Options</label>\n\t\t\t\t\t<div class=\"form-builder__options\"></div>\n\t\t\t\t\t<div class=\"form__group text-center\">\n\t\t\t\t\t\t<div class=\"button button--white button--border-blue button--small js-new-option\" style=\"margin-botom: 10px; display: inline-block;\">Add Option</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-builder__container--field__name\">field_name</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldColumn = docfragment.querySelector('.js-column-value');
        var fieldOptions = Array.from(fieldColumn.querySelectorAll('option'));
        if (fieldOptions) {
            fieldOptions.forEach(function (option) {
                var value = option.getAttribute('value');
                if (json.column) {
                    if (json.column === value) {
                        option.setAttribute('selected', 'true');
                    }
                }
            });
        }
        fieldColumn.addEventListener('change', function (e) {
            _this.buildPreview();
        });
        this.inputFocus(fieldColumn);
        var fieldLabel = docfragment.querySelector('.js-label-text');
        if (json.label) {
            fieldLabel.value = json.label;
            heading.innerHTML = json.label;
        }
        fieldLabel.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        this.inputFocus(fieldLabel);
        var fieldName = docfragment.querySelector('.js-name-text');
        var labelName = docfragment.querySelector('.form-builder__container--field__name');
        if (json.name) {
            fieldName.value = json.name;
            labelName.innerHTML = json.name;
        }
        fieldName.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            var value = element.value;
            element.setAttribute('value', value);
            labelName.innerHTML = value;
            _this.buildPreview();
        });
        this.inputFocus(fieldName);
        var containerOptions = docfragment.querySelector('.form-builder__options');
        var addOptionButton = docfragment.querySelector('.js-new-option');
        addOptionButton.addEventListener('click', function (e) {
            var option = "<div class=\"form-builder__options--option ui-kit__palette--shadow\">\n\t\t\t\t<div class=\"form-builder__options--option__remove\">Remove</div>\n\t\t\t\t<label class=\"form__label\">Text</label>\n\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-text\">\n\t\t\t\t<label class=\"form__label\">Value</label>\n\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-value\">\n\t\t\t</div>";
            var docfragmentOption = document.createDocumentFragment();
            docfragmentOption.appendChild(document.createRange().createContextualFragment(option));
            var removeButtonOption = docfragmentOption.querySelector('.form-builder__options--option__remove');
            removeButtonOption.addEventListener('click', function (e) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var parentContainer = element.closest('.form-builder__options--option');
                containerOptions.removeChild(parentContainer);
            });
            var optionText = docfragmentOption.querySelector('.js-option-text');
            optionText.addEventListener('keyup', function (e) {
                var element = undefined;
                element = e.target;
                element.setAttribute('value', element.value);
                _this.buildPreview();
            });
            _this.inputFocus(optionText);
            var optionValue = docfragmentOption.querySelector('.js-option-value');
            optionValue.addEventListener('keyup', function (e) {
                var element = undefined;
                element = e.target;
                element.setAttribute('value', element.value);
                _this.buildPreview();
            });
            _this.inputFocus(optionText);
            containerOptions.appendChild(docfragmentOption);
        });
        if (json.options) {
            json.options.forEach(function (item) {
                var option = "<div class=\"form-builder__options--option ui-kit__palette--shadow\">\n\t\t\t\t\t<div class=\"form-builder__options--option__remove\">Remove</div>\n\t\t\t\t\t<label class=\"form__label\">Text</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-text\">\n\t\t\t\t\t<label class=\"form__label\">Value</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-value\">\n\t\t\t\t</div>";
                var docfragmentOption = document.createDocumentFragment();
                docfragmentOption.appendChild(document.createRange().createContextualFragment(option));
                var removeButtonOption = docfragmentOption.querySelector('.form-builder__options--option__remove');
                removeButtonOption.addEventListener('click', function (e) {
                    var element = undefined;
                    if (event.currentTarget) {
                        element = event.currentTarget;
                    }
                    else {
                        element = event.target;
                    }
                    var parentContainer = element.closest('.form-builder__options--option');
                    containerOptions.removeChild(parentContainer);
                });
                var optionText = docfragmentOption.querySelector('.js-option-text');
                if (item.name) {
                    optionText.value = item.name;
                }
                optionText.addEventListener('keyup', function (e) {
                    var element = undefined;
                    element = e.target;
                    element.setAttribute('value', element.value);
                    _this.buildPreview();
                });
                _this.inputFocus(optionText);
                var optionValue = docfragmentOption.querySelector('.js-option-value');
                if (item.value) {
                    optionValue.value = item.value;
                }
                optionValue.addEventListener('keyup', function (e) {
                    var element = undefined;
                    element = e.target;
                    element.setAttribute('value', element.value);
                    _this.buildPreview();
                });
                _this.inputFocus(optionValue);
                containerOptions.appendChild(docfragmentOption);
            });
        }
        else {
            var defaultOptions = [
                {
                    name: 'Item 1',
                    value: 'Item 1',
                },
                {
                    name: 'Item 2',
                    value: 'Item 2',
                },
                {
                    name: 'Item 3',
                    value: 'Item 3',
                }
            ];
            if (defaultOptions) {
                defaultOptions.forEach(function (item) {
                    var option = "<div class=\"form-builder__options--option ui-kit__palette--shadow\">\n\t\t\t\t\t\t<div class=\"form-builder__options--option__remove\">Remove</div>\n\t\t\t\t\t\t<label class=\"form__label\">Text</label>\n\t\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-text\">\n\t\t\t\t\t\t<label class=\"form__label\">Value</label>\n\t\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-option-value\">\n\t\t\t\t\t</div>";
                    var docfragmentOption = document.createDocumentFragment();
                    docfragmentOption.appendChild(document.createRange().createContextualFragment(option));
                    var removeButtonOption = docfragmentOption.querySelector('.form-builder__options--option__remove');
                    removeButtonOption.addEventListener('click', function (e) {
                        var element = undefined;
                        if (event.currentTarget) {
                            element = event.currentTarget;
                        }
                        else {
                            element = event.target;
                        }
                        var parentContainer = element.closest('.form-builder__options--option');
                        containerOptions.removeChild(parentContainer);
                        _this.buildPreview();
                    });
                    var optionText = docfragmentOption.querySelector('.js-option-text');
                    if (item.name) {
                        optionText.value = item.name;
                    }
                    optionText.addEventListener('keyup', function (e) {
                        var element = undefined;
                        element = e.target;
                        element.setAttribute('value', element.value);
                        _this.buildPreview();
                    });
                    _this.inputFocus(optionText);
                    var optionValue = docfragmentOption.querySelector('.js-option-value');
                    if (item.value) {
                        optionValue.value = item.value;
                    }
                    optionValue.addEventListener('keyup', function (e) {
                        var element = undefined;
                        element = e.target;
                        element.setAttribute('value', element.value);
                        _this.buildPreview();
                    });
                    _this.inputFocus(optionValue);
                    containerOptions.appendChild(docfragmentOption);
                });
            }
        }
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldIdPassport = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"passport\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype\">ID / Passport</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">ID / Passport</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Column</label>\n\t\t\t\t\t<select class=\"form__input js-column-value\">\n\t\t\t\t\t\t<option value=\"col-md-12\">Fullwidth</option>\n\t\t\t\t\t\t<option value=\"col-md-6\">Half</option>\n\t\t\t\t\t\t<option value=\"col-md-4\">Third</option>\n\t\t\t\t\t\t<option value=\"col-md-8\">Two Thirds</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<label class=\"form__label\">Required</label>\n\t\t\t\t\t<div class=\"form__group\">\n\t\t\t\t\t\t<label class=\"form__control form__control--checkbox\">Required\n\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"js-required-field\">\n\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldColumn = docfragment.querySelector('.js-column-value');
        var fieldOptions = Array.from(fieldColumn.querySelectorAll('option'));
        if (fieldOptions) {
            fieldOptions.forEach(function (option) {
                var value = option.getAttribute('value');
                if (json.column) {
                    if (json.column === value) {
                        option.setAttribute('selected', 'true');
                    }
                }
            });
        }
        fieldColumn.addEventListener('change', function (e) {
            _this.buildPreview();
        });
        var fieldRequired = docfragment.querySelector('.js-required-field');
        fieldRequired.addEventListener('click', function (e) {
            if (fieldRequired.getAttribute('checked')) {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
            else {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            _this.buildPreview();
        });
        if (json.required) {
            if (json.required === true) {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            else {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
        }
        this.inputFocus(fieldRequired);
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldCountries = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"countries\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype\">Country</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">Country</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Column</label>\n\t\t\t\t\t<select class=\"form__input js-column-value\">\n\t\t\t\t\t\t<option value=\"col-md-12\">Fullwidth</option>\n\t\t\t\t\t\t<option value=\"col-md-6\">Half</option>\n\t\t\t\t\t\t<option value=\"col-md-4\">Third</option>\n\t\t\t\t\t\t<option value=\"col-md-8\">Two Thirds</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<label class=\"form__label\">Label</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-label-text\" value=\"Country\">\n\t\t\t\t\t<label class=\"form__label\">Field Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-name-text\" value=\"field_name\">\n\t\t\t\t\t<label class=\"form__label\">Required</label>\n\t\t\t\t\t<div class=\"form__group\">\n\t\t\t\t\t\t<label class=\"form__control form__control--checkbox\">Required\n\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"js-required-field\">\n\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-builder__container--field__name\">field_name</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldColumn = docfragment.querySelector('.js-column-value');
        var fieldOptions = Array.from(fieldColumn.querySelectorAll('option'));
        if (fieldOptions) {
            fieldOptions.forEach(function (option) {
                var value = option.getAttribute('value');
                if (json.column) {
                    if (json.column === value) {
                        option.setAttribute('selected', 'true');
                    }
                }
            });
        }
        fieldColumn.addEventListener('change', function (e) {
            _this.buildPreview();
        });
        this.inputFocus(fieldColumn);
        var fieldLabel = docfragment.querySelector('.js-label-text');
        if (json.label) {
            fieldLabel.value = json.label;
            heading.innerHTML = json.label;
        }
        fieldLabel.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        this.inputFocus(fieldLabel);
        var fieldName = docfragment.querySelector('.js-name-text');
        var labelName = docfragment.querySelector('.form-builder__container--field__name');
        if (json.name) {
            fieldName.value = json.name;
            labelName.innerHTML = json.name;
        }
        fieldName.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            var value = element.value;
            element.setAttribute('value', value);
            labelName.innerHTML = value;
            _this.buildPreview();
        });
        this.inputFocus(fieldName);
        var fieldRequired = docfragment.querySelector('.js-required-field');
        fieldRequired.addEventListener('click', function (e) {
            if (fieldRequired.getAttribute('checked')) {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
            else {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            _this.buildPreview();
        });
        if (json.required) {
            if (json.required === true) {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            else {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
        }
        this.inputFocus(fieldRequired);
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldProvinces = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"provinces\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype\">Province</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">Province</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Column</label>\n\t\t\t\t\t<select class=\"form__input js-column-value\">\n\t\t\t\t\t\t<option value=\"col-md-12\">Fullwidth</option>\n\t\t\t\t\t\t<option value=\"col-md-6\">Half</option>\n\t\t\t\t\t\t<option value=\"col-md-4\">Third</option>\n\t\t\t\t\t\t<option value=\"col-md-8\">Two Thirds</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<label class=\"form__label\">Label</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-label-text\" value=\"Province\">\n\t\t\t\t\t<label class=\"form__label\">Field Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-name-text\" value=\"field_name\">\n\t\t\t\t\t<label class=\"form__label\">Required</label>\n\t\t\t\t\t<div class=\"form__group\">\n\t\t\t\t\t\t<label class=\"form__control form__control--checkbox\">Required\n\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"js-required-field\">\n\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-builder__container--field__name\">field_name</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldColumn = docfragment.querySelector('.js-column-value');
        var fieldOptions = Array.from(fieldColumn.querySelectorAll('option'));
        if (fieldOptions) {
            fieldOptions.forEach(function (option) {
                var value = option.getAttribute('value');
                if (json.column) {
                    if (json.column === value) {
                        option.setAttribute('selected', 'true');
                    }
                }
            });
        }
        fieldColumn.addEventListener('change', function (e) {
            _this.buildPreview();
        });
        this.inputFocus(fieldColumn);
        var fieldLabel = docfragment.querySelector('.js-label-text');
        if (json.label) {
            fieldLabel.value = json.label;
            heading.innerHTML = json.label;
        }
        fieldLabel.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        this.inputFocus(fieldLabel);
        var fieldName = docfragment.querySelector('.js-name-text');
        var labelName = docfragment.querySelector('.form-builder__container--field__name');
        if (json.name) {
            fieldName.value = json.name;
            labelName.innerHTML = json.name;
        }
        fieldName.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            var value = element.value;
            element.setAttribute('value', value);
            labelName.innerHTML = value;
            _this.buildPreview();
        });
        this.inputFocus(fieldName);
        var fieldRequired = docfragment.querySelector('.js-required-field');
        fieldRequired.addEventListener('click', function (e) {
            if (fieldRequired.getAttribute('checked')) {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
            else {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            _this.buildPreview();
        });
        if (json.required) {
            if (json.required === true) {
                var requiredSpan = document.createElement('span');
                requiredSpan.style.color = "#FF0000";
                requiredSpan.innerHTML = '*';
                heading.appendChild(requiredSpan);
                fieldRequired.setAttribute('checked', 'true');
            }
            else {
                var requiredSpan = heading.querySelector('span');
                heading.removeChild(requiredSpan);
                fieldRequired.removeAttribute('checked');
            }
        }
        this.inputFocus(fieldRequired);
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    FormBuilder.prototype.addFieldButtonSubmit = function (json) {
        var _this = this;
        if (json === void 0) { json = {}; }
        var output = "<div class=\"form-builder__container--field ui-kit__palette--shadow js-generic-form-field\" draggable=\"true\" type=\"button-submit\">\n\t\t\t<div class=\"form-builder__container--field__fieldtype\">Button</div>\n\t\t\t<div class=\"form-builder__container--field__remove\">X</div>\n\t\t\t<div class=\"form-builder__container--field__title\">Apply Now</div>\n\t\t\t<div class=\"form-builder__container--field__settings\">\n\t\t\t\t<div class=\"form-builder__container--field__settings--formgroup\">\n\t\t\t\t\t<label class=\"form__label\">Label</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Enter your text\" class=\"form__input js-label-text\" value=\"Apply Now\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-builder__container--field__name\">field_name</div>\n\t\t</div>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        var container = docfragment.querySelector('.js-generic-form-field');
        var heading = docfragment.querySelector('.form-builder__container--field__title');
        heading.onclick = function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var closest = element.closest('.form-builder__container--field');
            var settings = closest.querySelector('.form-builder__container--field__settings');
            if (settings.classList.contains('open')) {
                element.classList.remove('open');
                settings.classList.remove('open');
            }
            else {
                _this.openCloseFieldTitle(settings);
            }
        };
        var removeButtom = docfragment.querySelector('.form-builder__container--field__remove');
        removeButtom.onclick = function (event) { _this.buttonRemove(event); };
        var fieldLabel = docfragment.querySelector('.js-label-text');
        if (json.label) {
            fieldLabel.value = json.label;
            heading.innerHTML = json.label;
        }
        fieldLabel.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            element.setAttribute('value', element.value);
            heading.innerHTML = element.value;
            _this.buildPreview();
        });
        this.inputFocus(fieldLabel);
        this.containerFieldsComponents.appendChild(docfragment);
        this.sortable();
        this.buildPreview();
    };
    //////////////////////////////////////
    //////////////////////////////////////
    // GENERIC FORM - BUILDING FIELD
    //////////////////////////////////////
    //////////////////////////////////////
    FormBuilder.prototype.buildFieldHeading = function (field) {
        var text = field.querySelector('.js-heading-text');
        var output = "<div class=\"col-12\"><div class=\"title title--module-title\">" + text.value + "</div></div>";
        var json = {
            type: 'heading',
            value: text.value
        };
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldParagraph = function (field) {
        var text = field.querySelector('.js-paragraph-text');
        var output = "<div class=\"col-12\"><p>" + text.value + "</p></div>";
        var json = {
            type: 'paragraph',
            value: text.value
        };
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldInput = function (field) {
        var name = field.querySelector('.js-name-text');
        var label = field.querySelector('.js-label-text');
        var placeholder = field.querySelector('.js-placeholder-text');
        var required = field.querySelector('.js-required-field');
        var column = field.querySelector('.js-column-value');
        var newInputName = '';
        if (name.value === 'field_name') {
            newInputName = this.camelCase(label.value);
        }
        else {
            newInputName = name.value;
        }
        var output = "<div class=\"" + column.value + "\">\n\t\t\t<div class=\"form__group \">\n\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t" + label.value + "\n\t\t\t\t</label>\n\t\t\t\t<input type=\"text\" name=\"" + newInputName + "\" value=\"\" class=\"form__input\" placeholder=\"" + placeholder.value + "\">\n\t\t\t</div>\n\t\t</div>";
        var json = {
            type: 'input',
            column: column.value,
            name: name.value,
            label: label.value,
            placeholder: placeholder.value,
            required: false
        };
        if (required.getAttribute('checked')) {
            output = "<div class=\"" + column.value + "\">\n\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t" + label.value + "\n\t\t\t\t\t</label>\n\t\t\t\t\t<input type=\"text\" name=\"" + name.value + "\" value=\"\" class=\"form__input  form__input--required\" placeholder=\"" + placeholder.value + "\">\n\t\t\t\t</div>\n\t\t\t</div>";
            json.required = true;
        }
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldInputNumber = function (field) {
        var name = field.querySelector('.js-name-text');
        var label = field.querySelector('.js-label-text');
        var placeholder = field.querySelector('.js-placeholder-text');
        var required = field.querySelector('.js-required-field');
        var column = field.querySelector('.js-column-value');
        var newInputName = '';
        if (name.value === 'field_name') {
            newInputName = this.camelCase(label.value);
        }
        else {
            newInputName = name.value;
        }
        var output = "<div class=\"" + column.value + "\">\n\t\t\t<div class=\"form__group \">\n\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t" + label.value + "\n\t\t\t\t</label>\n\t\t\t\t<input type=\"number\" name=\"" + newInputName + "\" value=\"\" class=\"form__input\" placeholder=\"" + placeholder.value + "\">\n\t\t\t</div>\n\t\t</div>";
        var json = {
            type: 'number',
            column: column.value,
            name: name.value,
            label: label.value,
            placeholder: placeholder.value,
            required: false
        };
        if (required.getAttribute('checked')) {
            output = "<div class=\"" + column.value + "\">\n\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t" + label.value + "\n\t\t\t\t\t</label>\n\t\t\t\t\t<input type=\"number\" name=\"" + name.value + "\" value=\"\" class=\"form__input  form__input--required\" placeholder=\"" + placeholder.value + "\">\n\t\t\t\t</div>\n\t\t\t</div>";
            json.required = true;
        }
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldInputEmail = function (field) {
        var name = field.querySelector('.js-name-text');
        var label = field.querySelector('.js-label-text');
        var placeholder = field.querySelector('.js-placeholder-text');
        var required = field.querySelector('.js-required-field');
        var column = field.querySelector('.js-column-value');
        var newInputName = '';
        if (name.value === 'field_name') {
            newInputName = this.camelCase(label.value);
        }
        else {
            newInputName = name.value;
        }
        var output = "<div class=\"" + column.value + "\">\n\t\t\t<div class=\"form__group \">\n\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t" + label.value + "\n\t\t\t\t</label>\n\t\t\t\t<input type=\"text\" name=\"" + newInputName + "\" value=\"\" class=\"form__input form__input--email\" placeholder=\"" + placeholder.value + "\">\n\t\t\t</div>\n\t\t</div>";
        var json = {
            type: 'email',
            column: column.value,
            name: name.value,
            label: label.value,
            placeholder: placeholder.value,
            required: false
        };
        if (required.getAttribute('checked')) {
            output = "<div class=\"" + column.value + "\">\n\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t" + label.value + "\n\t\t\t\t\t</label>\n\t\t\t\t\t<input type=\"text\" name=\"" + name.value + "\" value=\"\" class=\"form__input form__input--email form__input--required\" placeholder=\"" + placeholder.value + "\">\n\t\t\t\t</div>\n\t\t\t</div>";
            json.required = true;
        }
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldTextarea = function (field) {
        var name = field.querySelector('.js-name-text');
        var label = field.querySelector('.js-label-text');
        var placeholder = field.querySelector('.js-placeholder-text');
        var required = field.querySelector('.js-required-field');
        var column = field.querySelector('.js-column-value');
        var newInputName = '';
        if (name.value === 'field_name') {
            newInputName = this.camelCase(label.value);
        }
        else {
            newInputName = name.value;
        }
        var output = "<div class=\"" + column.value + "\">\n\t\t\t<div class=\"form__group \">\n\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t" + label.value + "\n\t\t\t\t</label>\n\t\t\t\t<textarea name=\"" + newInputName + "\" value=\"\" maxlength=\"200\" class=\"form__textarea form__input--minmaxLength\" placeholder=\"" + placeholder.value + "\" rows=\"5\"></textarea>\n\t\t\t</div>\n\t\t</div>";
        var json = {
            type: 'textarea',
            column: column.value,
            name: name.value,
            label: label.value,
            placeholder: placeholder.value,
            required: false
        };
        if (required.getAttribute('checked')) {
            output = "<div class=\"" + column.value + "\">\n\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t" + label.value + "\n\t\t\t\t\t</label>\n\t\t\t\t\t<textarea name=\"" + name.value + "\" value=\"\" maxlength=\"200\" class=\"form__textarea form__input--minmaxLength form__input--required\" placeholder=\"" + placeholder.value + "\" rows=\"5\"></textarea>\n\t\t\t\t</div>\n\t\t\t</div>";
            json.required = true;
        }
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldDate = function (field) {
        var name = field.querySelector('.js-name-text');
        var label = field.querySelector('.js-label-text');
        var placeholder = field.querySelector('.js-placeholder-text');
        var required = field.querySelector('.js-required-field');
        var column = field.querySelector('.js-column-value');
        var newInputName = '';
        if (name.value === 'field_name') {
            newInputName = this.camelCase(label.value);
        }
        else {
            newInputName = name.value;
        }
        var output = "<div class=\"" + column.value + "\">\n\t\t\t<div class=\"form__group \">\n\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t" + label.value + "\n\t\t\t\t</label>\n\t\t\t\t<input type=\"date\" name=\"" + newInputName + "\" value=\"\" class=\"form__input\" placeholder=\"" + placeholder.value + "\">\n\t\t\t</div>\n\t\t</div>";
        var json = {
            type: 'date',
            column: column.value,
            name: name.value,
            label: label.value,
            placeholder: placeholder.value,
            required: false
        };
        if (required.getAttribute('checked')) {
            output = "<div class=\"" + column.value + "\">\n\t\t\t\t<div class=\"form__group \">\n\t\t\t\t\t<label class=\"form__label\">\n\t\t\t\t\t\t" + label.value + "\n\t\t\t\t\t</label>\n\t\t\t\t\t<input type=\"date\" name=\"" + name.value + "\" value=\"\" class=\"form__input form__input--required\" placeholder=\"" + placeholder.value + "\">\n\t\t\t\t</div>\n\t\t\t</div>";
            json.required = true;
        }
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldDropdown = function (field) {
        var column = field.querySelector('.js-column-value');
        var name = field.querySelector('.js-name-text');
        var label = field.querySelector('.js-label-text');
        var required = field.querySelector('.js-required-field');
        var options = field.querySelectorAll('.form-builder__options--option');
        var output = "<div class=\"" + column.value + "\">";
        output += "<div class=\"form__group\">";
        output += "<label class=\"form__label\">" + label.value + "</label>";
        var newInputName = '';
        if (name.value === 'field_name') {
            newInputName = this.camelCase(label.value);
        }
        else {
            newInputName = name.value;
        }
        var json = {
            type: 'dropdown',
            column: column.value,
            name: name.value,
            label: label.value,
            options: [],
            required: false
        };
        var optionsOutput = "";
        [].forEach.call(options, function (option) {
            var optionText = option.querySelector('.js-option-text');
            var optionValue = option.querySelector('.js-option-value');
            optionsOutput += "<option value=\"" + optionValue.value + "\">" + optionText.value + "</option>";
            json.options.push({
                name: optionText.value,
                value: optionValue.value
            });
        });
        if (required.getAttribute('checked')) {
            output += "<select class=\"form__input form__input--required\" name=\"\"" + newInputName + "\">" + optionsOutput + "</select>";
            json.required = true;
        }
        else {
            output += "<select class=\"form__input\" name=\"\"" + newInputName + "\">" + optionsOutput + "</select>";
            json.required = false;
        }
        output += "</div>";
        output += "</div>";
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldIconText = function (field) {
        var icon = field.querySelector('.js-icon-value');
        var text = field.querySelector('.js-text-value');
        var iconDisplay = "<img src='/file_source/assets/icons/icon-lock.svg'>";
        if (icon.value) {
            iconDisplay = icon.value;
        }
        var output = "<div class=\"col-12\">\n\t\t\t<div class=\"apply-now__note\">\n\t\t\t\t<div class=\"apply-now__note-icon\">" + iconDisplay + "</div>\n\t\t\t\t<div class=\"apply-now__note-text\">\n\t\t\t\t\t" + text.value + "\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>";
        var json = {
            type: 'icontext',
            icon: icon.value,
            text: text.value
        };
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldCheckbox = function (field) {
        var column = field.querySelector('.js-column-value');
        var name = field.querySelector('.js-name-text');
        var label = field.querySelector('.js-label-text');
        var options = field.querySelectorAll('.form-builder__options--option');
        var output = "<div class=\"" + column.value + "\">";
        output += "<div class=\"form__group\">";
        output += "<label class=\"form__label\">" + label.value + "</label>";
        output += "<div class=\"row\">";
        var newInputName = '';
        if (name.value === 'field_name') {
            newInputName = this.camelCase(label.value);
        }
        else {
            newInputName = name.value;
        }
        var json = {
            type: 'checkbox',
            column: column.value,
            name: name.value,
            label: label.value,
            options: [],
            required: false
        };
        var optionsOutput = "";
        [].forEach.call(options, function (option) {
            var optionText = option.querySelector('.js-option-text');
            var optionValue = option.querySelector('.js-option-value');
            optionsOutput += "<div class=\"col-md-6\">\n\t\t\t\t<label class=\"form__label filter-builder__form-field--checkboxlabel\">\n\t\t\t\t<div class=\"form__control\">\n\t\t\t\t\t<span class=\"form__control--checkbox-title\">" + optionText.value + "</span>\n\t\t\t\t\t<div class=\"form__control--checkbox\">\t\t\t\t\t\t\t\n\t\t\t\t\t\t<input type=\"checkbox\" class=\"form__input\" name=\"" + newInputName + "\" data-value=\"" + optionValue.value + "\" value=\"" + optionValue.value + "\">\n\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t</div>\t\t\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t</label>\n\t\t\t</div>";
            json.options.push({
                name: optionText.value,
                value: optionValue.value
            });
        });
        output += optionsOutput;
        output += "</div>";
        output += "</div>";
        output += "</div>";
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldRadio = function (field) {
        var column = field.querySelector('.js-column-value');
        var name = field.querySelector('.js-name-text');
        var label = field.querySelector('.js-label-text');
        var options = field.querySelectorAll('.form-builder__options--option');
        var output = "<div class=\"" + column.value + "\">";
        output += "<div class=\"form__group\">";
        output += "<label class=\"form__label\">" + label.value + "</label>";
        output += "<div class=\"apply-now__radio\">";
        var newInputName = '';
        if (name.value === 'field_name') {
            newInputName = this.camelCase(label.value);
        }
        else {
            newInputName = name.value;
        }
        var json = {
            type: 'radio',
            column: column.value,
            name: name.value,
            label: label.value,
            options: []
        };
        var index = 0;
        var optionsOutput = "";
        [].forEach.call(options, function (option) {
            var optionText = option.querySelector('.js-option-text');
            var optionValue = option.querySelector('.js-option-value');
            if (index === 0) {
                optionsOutput += "<label class=\"form__control form__control--radio\">\n\t\t\t\t\t" + optionText.value + "\n\t\t\t\t\t<input type=\"radio\" checked=\"checked\" name=\"" + newInputName + "\" value=\"" + optionValue.value + "\"\n\t\t\t\t\t\tclass=\"js-radio-group\">\n\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t</label>";
            }
            else {
                optionsOutput += "<label class=\"form__control form__control--radio\">\n\t\t\t\t\t" + optionText.value + "\n\t\t\t\t\t<input type=\"radio\" name=\"" + newInputName + "\" value=\"" + optionValue.value + "\"\n\t\t\t\t\t\tclass=\"js-radio-group\">\n\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t</label>";
            }
            json.options.push({
                name: optionText.value,
                value: optionValue.value
            });
            index++;
        });
        output += optionsOutput;
        output += "</div>";
        output += "</div>";
        output += "</div>";
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldIdPassport = function (field) {
        var column = field.querySelector('.js-column-value');
        var output = "<div class=\"" + column.value + "\">\n\t\t\t<div class=\"form__group form__group--w-addon\">\n\t\t\t\t<div class=\"apply-now__radio\">\n\t\t\t\t\t<label class=\"form__control form__control--radio\">\n\t\t\t\t\t\tID Number\n\t\t\t\t\t\t<input type=\"radio\" name=\"identification-type\" value=\"said\" class=\"js-identification_radio--group\"\n\t\t\t\t\t\t\tchecked=\"checked\">\n\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t</label>\n\t\t\t\t\t<label class=\"form__control form__control--radio\">\n\t\t\t\t\t\tPassport\n\t\t\t\t\t\t<input type=\"radio\" name=\"identification-type\" value=\"passport\" class=\"js-identification_radio--group\">\n\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form__group\">\n\t\t\t\t<label class=\"form__label\"></label>\n\t\t\t\t<input type=\"number\" name=\"identification\" value=\"\" class=\"form__input  form__input--required form__input--identification \" placeholder=\"Enter your South Africa ID number / Enter your Passport number\">\n\t\t\t</div>\n\t\t</div>";
        var json = {
            type: 'passport',
            column: column.value
        };
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldCountries = function (field) {
        var column = field.querySelector('.js-column-value');
        var name = field.querySelector('.js-name-text');
        var label = field.querySelector('.js-label-text');
        var required = field.querySelector('.js-required-field');
        var output = "<div class=\"" + column.value + "\">";
        output += "<div class=\"form__group\">";
        output += "<label class=\"form__label\">" + label.value + "</label>";
        var newInputName = '';
        if (name.value === 'field_name') {
            newInputName = this.camelCase(label.value);
        }
        else {
            newInputName = name.value;
        }
        var json = {
            type: 'countries',
            column: column.value,
            name: name.value,
            label: label.value,
            required: false
        };
        var optionsOutput = "";
        var options = [
            { text: "Select a country", value: ""
            },
            { text: "Afghanistan", value: "Afghanistan"
            },
            { text: "Albania", value: "Albania"
            },
            { text: "Algeria", value: "Algeria"
            },
            { text: "Andorra", value: "Andorra"
            },
            { text: "Angola", value: "Angola"
            },
            { text: "Antigua & Deps", value: "Antigua & Deps"
            },
            { text: "Argentina", value: "Argentina"
            },
            { text: "Armenia", value: "Armenia"
            },
            { text: "Australia", value: "Australia"
            },
            { text: "Austria", value: "Austria"
            },
            { text: "Azerbaijan", value: "Azerbaijan"
            },
            { text: "Bahamas", value: "Bahamas"
            },
            { text: "Bahrain", value: "Bahrain"
            },
            { text: "Bangladesh", value: "Bangladesh"
            },
            { text: "Barbados", value: "Barbados"
            },
            { text: "Belarus", value: "Belarus"
            },
            { text: "Belgium", value: "Belgium"
            },
            { text: "Belize", value: "Belize"
            },
            { text: "Benin", value: "Benin"
            },
            { text: "Bhutan", value: "Bhutan"
            },
            { text: "Bolivia", value: "Bolivia"
            },
            { text: "Bosnia Herzegovina", value: "Bosnia Herzegovina"
            },
            { text: "Botswana", value: "Botswana"
            },
            { text: "Brazil", value: "Brazil"
            },
            { text: "Brunei", value: "Brunei"
            },
            { text: "Bulgaria", value: "Bulgaria"
            },
            { text: "Burkina", value: "Burkina"
            },
            { text: "Burundi", value: "Burundi"
            },
            { text: "Cambodia", value: "Cambodia"
            },
            { text: "Cameroon", value: "Cameroon"
            },
            { text: "Canada", value: "Canada"
            },
            { text: "Cape Verde", value: "Cape Verde"
            },
            { text: "Central African Rep", value: "Central African Rep"
            },
            { text: "Chad", value: "Chad"
            },
            { text: "Chile", value: "Chile"
            },
            { text: "China", value: "China"
            },
            { text: "Colombia", value: "Colombia"
            },
            { text: "Comoros", value: "Comoros"
            },
            { text: "Congo", value: "Congo"
            },
            { text: "Congo {Democratic Rep}", value: "Congo {Democratic Rep}"
            },
            { text: "Costa Rica", value: "Costa Rica"
            },
            { text: "Croatia", value: "Croatia"
            },
            { text: "Cuba", value: "Cuba"
            },
            { text: "Cyprus", value: "Cyprus"
            },
            { text: "Czech Republic", value: "Czech Republic"
            },
            { text: "Denmark", value: "Denmark"
            },
            { text: "Djibouti", value: "Djibouti"
            },
            { text: "Dominica", value: "Dominica"
            },
            { text: "Dominican Republic", value: "Dominican Republic"
            },
            { text: "East Timor", value: "East Timor"
            },
            { text: "Ecuador", value: "Ecuador"
            },
            { text: "Egypt", value: "Egypt"
            },
            { text: "El Salvador", value: "El Salvador"
            },
            { text: "Equatorial Guinea", value: "Equatorial Guinea"
            },
            { text: "Eritrea", value: "Eritrea"
            },
            { text: "Estonia", value: "Estonia"
            },
            { text: "Ethiopia", value: "Ethiopia"
            },
            { text: "Fiji", value: "Fiji"
            },
            { text: "Finland", value: "Finland"
            },
            { text: "France", value: "France"
            },
            { text: "Gabon", value: "Gabon"
            },
            { text: "Gambia", value: "Gambia"
            },
            { text: "Georgia", value: "Georgia"
            },
            { text: "Germany", value: "Germany"
            },
            { text: "Ghana", value: "Ghana"
            },
            { text: "Greece", value: "Greece"
            },
            { text: "Grenada", value: "Grenada"
            },
            { text: "Guatemala", value: "Guatemala"
            },
            { text: "Guinea", value: "Guinea"
            },
            { text: "Guinea-Bissau", value: "Guinea-Bissau"
            },
            { text: "Guyana", value: "Guyana"
            },
            { text: "Haiti", value: "Haiti"
            },
            { text: "Honduras", value: "Honduras"
            },
            { text: "Hungary", value: "Hungary"
            },
            { text: "Iceland", value: "Iceland"
            },
            { text: "India", value: "India"
            },
            { text: "Indonesia", value: "Indonesia"
            },
            { text: "Iran", value: "Iran"
            },
            { text: "Iraq", value: "Iraq"
            },
            { text: "Ireland {Republic}", value: "Ireland {Republic}"
            },
            { text: "Israel", value: "Israel"
            },
            { text: "Italy", value: "Italy"
            },
            { text: "Ivory Coast", value: "Ivory Coast"
            },
            { text: "Jamaica", value: "Jamaica"
            },
            { text: "Japan", value: "Japan"
            },
            { text: "Jordan", value: "Jordan"
            },
            { text: "Kazakhstan", value: "Kazakhstan"
            },
            { text: "Kenya", value: "Kenya"
            },
            { text: "Kiribati", value: "Kiribati"
            },
            { text: "Korea North", value: "Korea North"
            },
            { text: "Korea South", value: "Korea South"
            },
            { text: "Kosovo", value: "Kosovo"
            },
            { text: "Kuwait", value: "Kuwait"
            },
            { text: "Kyrgyzstan", value: "Kyrgyzstan"
            },
            { text: "Laos", value: "Laos"
            },
            { text: "Latvia", value: "Latvia"
            },
            { text: "Lebanon", value: "Lebanon"
            },
            { text: "Lesotho", value: "Lesotho"
            },
            { text: "Liberia", value: "Liberia"
            },
            { text: "Libya", value: "Libya"
            },
            { text: "Liechtenstein", value: "Liechtenstein"
            },
            { text: "Lithuania", value: "Lithuania"
            },
            { text: "Luxembourg", value: "Luxembourg"
            },
            { text: "Macedonia", value: "Macedonia"
            },
            { text: "Madagascar", value: "Madagascar"
            },
            { text: "Malawi", value: "Malawi"
            },
            { text: "Malaysia", value: "Malaysia"
            },
            { text: "Maldives", value: "Maldives"
            },
            { text: "Mali", value: "Mali"
            },
            { text: "Malta", value: "Malta"
            },
            { text: "Marshall Islands", value: "Marshall Islands"
            },
            { text: "Mauritania", value: "Mauritania"
            },
            { text: "Mauritius", value: "Mauritius"
            },
            { text: "Mexico", value: "Mexico"
            },
            { text: "Micronesia", value: "Micronesia"
            },
            { text: "Moldova", value: "Moldova"
            },
            { text: "Monaco", value: "Monaco"
            },
            { text: "Mongolia", value: "Mongolia"
            },
            { text: "Montenegro", value: "Montenegro"
            },
            { text: "Morocco", value: "Morocco"
            },
            { text: "Mozambique", value: "Mozambique"
            },
            { text: "Myanmar, {Burma}", value: "Myanmar, {Burma}"
            },
            { text: "Namibia", value: "Namibia"
            },
            { text: "Nauru", value: "Nauru"
            },
            { text: "Nepal", value: "Nepal"
            },
            { text: "Netherlands", value: "Netherlands"
            },
            { text: "New Zealand", value: "New Zealand"
            },
            { text: "Nicaragua", value: "Nicaragua"
            },
            { text: "Niger", value: "Niger"
            },
            { text: "Nigeria", value: "Nigeria"
            },
            { text: "Norway", value: "Norway"
            },
            { text: "Oman", value: "Oman"
            },
            { text: "Pakistan", value: "Pakistan"
            },
            { text: "Palau", value: "Palau"
            },
            { text: "Panama", value: "Panama"
            },
            { text: "Papua New Guinea", value: "Papua New Guinea"
            },
            { text: "Paraguay", value: "Paraguay"
            },
            { text: "Peru", value: "Peru"
            },
            { text: "Philippines", value: "Philippines"
            },
            { text: "Poland", value: "Poland"
            },
            { text: "Portugal", value: "Portugal"
            },
            { text: "Qatar", value: "Qatar"
            },
            { text: "Romania", value: "Romania"
            },
            { text: "Russian Federation", value: "Russian Federation"
            },
            { text: "Rwanda", value: "Rwanda"
            },
            { text: "St Kitts & Nevis", value: "St Kitts & Nevis"
            },
            { text: "St Lucia", value: "St Lucia"
            },
            { text: "Saint Vincent & the Grenadines", value: "Saint Vincent & the Grenadines"
            },
            { text: "Samoa", value: "Samoa"
            },
            { text: "San Marino", value: "San Marino"
            },
            { text: "Sao Tome & Principe", value: "Sao Tome & Principe"
            },
            { text: "Saudi Arabia", value: "Saudi Arabia"
            },
            { text: "Senegal", value: "Senegal"
            },
            { text: "Serbia", value: "Serbia"
            },
            { text: "Seychelles", value: "Seychelles"
            },
            { text: "Sierra Leone", value: "Sierra Leone"
            },
            { text: "Singapore", value: "Singapore"
            },
            { text: "Slovakia", value: "Slovakia"
            },
            { text: "Slovenia", value: "Slovenia"
            },
            { text: "Solomon Islands", value: "Solomon Islands"
            },
            { text: "Somalia", value: "Somalia"
            },
            { text: "South Africa", value: "South Africa"
            },
            { text: "South Sudan", value: "South Sudan"
            },
            { text: "Spain", value: "Spain"
            },
            { text: "Sri Lanka", value: "Sri Lanka"
            },
            { text: "Sudan", value: "Sudan"
            },
            { text: "Suriname", value: "Suriname"
            },
            { text: "Swaziland", value: "Swaziland"
            },
            { text: "Sweden", value: "Sweden"
            },
            { text: "Switzerland", value: "Switzerland"
            },
            { text: "Syria", value: "Syria"
            },
            { text: "Taiwan", value: "Taiwan"
            },
            { text: "Tajikistan", value: "Tajikistan"
            },
            { text: "Tanzania", value: "Tanzania"
            },
            { text: "Thailand", value: "Thailand"
            },
            { text: "Togo", value: "Togo"
            },
            { text: "Tonga", value: "Tonga"
            },
            { text: "Trinidad & Tobago", value: "Trinidad & Tobago"
            },
            { text: "Tunisia", value: "Tunisia"
            },
            { text: "Turkey", value: "Turkey"
            },
            { text: "Turkmenistan", value: "Turkmenistan"
            },
            { text: "Tuvalu", value: "Tuvalu"
            },
            { text: "Uganda", value: "Uganda"
            },
            { text: "Ukraine", value: "Ukraine"
            },
            { text: "United Arab Emirates", value: "United Arab Emirates"
            },
            { text: "United Kingdom", value: "United Kingdom"
            },
            { text: "United States", value: "United States"
            },
            { text: "Uruguay", value: "Uruguay"
            },
            { text: "Uzbekistan", value: "Uzbekistan"
            },
            { text: "Vanuatu", value: "Vanuatu"
            },
            { text: "Vatican City", value: "Vatican City"
            },
            { text: "Venezuela", value: "Venezuela"
            },
            { text: "Vietnam", value: "Vietnam"
            },
            { text: "Yemen", value: "Yemen"
            },
            { text: "Zambia", value: "Zambia"
            },
            { text: "Zimbabwe", value: "Zimbabwe"
            }
        ];
        options.forEach(function (option) {
            optionsOutput += "<option value=\"" + option.value + "\">" + option.text + "</option>";
        });
        if (required.getAttribute('checked')) {
            output += "<select class=\"form__input form__input--required\" name=\"\"" + newInputName + "\">" + optionsOutput + "</select>";
            json.required = true;
        }
        else {
            output += "<select class=\"form__input\" name=\"\"" + newInputName + "\">" + optionsOutput + "</select>";
            json.required = false;
        }
        output += "</div>";
        output += "</div>";
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldProvinces = function (field) {
        var column = field.querySelector('.js-column-value');
        var name = field.querySelector('.js-name-text');
        var label = field.querySelector('.js-label-text');
        var required = field.querySelector('.js-required-field');
        var output = "<div class=\"" + column.value + "\">";
        output += "<div class=\"form__group\">";
        output += "<label class=\"form__label\">" + label.value + "</label>";
        var newInputName = '';
        if (name.value === 'field_name') {
            newInputName = this.camelCase(label.value);
        }
        else {
            newInputName = name.value;
        }
        var json = {
            type: 'provinces',
            column: column.value,
            name: name.value,
            label: label.value,
            required: false
        };
        var optionsOutput = "";
        var options = [
            {
                text: 'Select a Province',
                value: ''
            },
            {
                text: 'Eastern Cape',
                value: 'Eastern Cape'
            },
            {
                text: 'Free State',
                value: 'Free State'
            },
            {
                text: 'Gauteng',
                value: 'Gauteng'
            },
            {
                text: 'KwaZulu-Natal',
                value: 'KwaZulu-Natal'
            },
            {
                text: 'Limpopo',
                value: 'Limpopo'
            },
            {
                text: 'Mpumalanga',
                value: 'Mpumalanga'
            },
            {
                text: 'North West',
                value: 'North West'
            },
            {
                text: 'Northern Cape',
                value: 'Northern Cape'
            },
            {
                text: 'Western Cape',
                value: 'Western Cape'
            }
        ];
        options.forEach(function (option) {
            optionsOutput += "<option value=\"" + option.value + "\">" + option.text + "</option>";
        });
        if (required.getAttribute('checked')) {
            output += "<select class=\"form__input form__input--required\" name=\"\"" + newInputName + "\">" + optionsOutput + "</select>";
            json.required = true;
        }
        else {
            output += "<select class=\"form__input\" name=\"\"" + newInputName + "\">" + optionsOutput + "</select>";
            json.required = false;
        }
        output += "</div>";
        output += "</div>";
        this.generatedJSON.push(json);
        return output;
    };
    FormBuilder.prototype.buildFieldButtonSubmit = function (field) {
        var label = field.querySelector('.js-label-text');
        var output = "<div class=\"col-12\">";
        output += "<div class=\"form__group\">";
        output += "<a class=\"button button--medium apply-now__button js-submit__generic-form\" href=\"javascript:void(0);\" target=\"\" data-modal=\"\" data-id=\"\" data-text=\"\">\n\t\t\t" + label.value + "\n\t\t</a>";
        output += "</div></div>";
        var json = {
            type: 'button-submit',
            label: label.value
        };
        this.generatedJSON.push(json);
        return output;
    };
    //////////////////////////////////////
    //////////////////////////////////////
    // BUILDING PREVIEW
    //////////////////////////////////////
    //////////////////////////////////////
    FormBuilder.prototype.buildPreview = function () {
        var _this = this;
        this.generatedJSON = [];
        this.containerPreview.innerHTML = '';
        this.containerPreviewModal.innerHTML = '';
        var fieldsHtml = "";
        var fields = Array.from(this.element.querySelectorAll('.form-builder__container--field'));
        fields.map(function (field) {
            var type = field.getAttribute('type');
            switch (type) {
                case 'heading':
                    fieldsHtml += _this.buildFieldHeading(field);
                    break;
                case 'paragraph':
                    fieldsHtml += _this.buildFieldParagraph(field);
                    break;
                case 'input':
                    fieldsHtml += _this.buildFieldInput(field);
                    break;
                case 'number':
                    fieldsHtml += _this.buildFieldInputNumber(field);
                    break;
                case 'email':
                    fieldsHtml += _this.buildFieldInputEmail(field);
                    break;
                case 'textarea':
                    fieldsHtml += _this.buildFieldTextarea(field);
                    break;
                case 'date':
                    fieldsHtml += _this.buildFieldDate(field);
                    break;
                case 'dropdown':
                    fieldsHtml += _this.buildFieldDropdown(field);
                    break;
                case 'icontext':
                    fieldsHtml += _this.buildFieldIconText(field);
                    break;
                case 'checkbox':
                    fieldsHtml += _this.buildFieldCheckbox(field);
                    break;
                case 'radio':
                    fieldsHtml += _this.buildFieldRadio(field);
                    break;
                case 'passport':
                    fieldsHtml += _this.buildFieldIdPassport(field);
                    break;
                case 'countries':
                    fieldsHtml += _this.buildFieldCountries(field);
                    break;
                case 'provinces':
                    fieldsHtml += _this.buildFieldProvinces(field);
                    break;
                case 'button-submit':
                    fieldsHtml += _this.buildFieldButtonSubmit(field);
                    break;
                default:
                    break;
            }
        });
        var content = fieldsHtml + ("<div class=\"col-12\">\n\t\t\t<div class=\"apply-now__buttons\">\n\t\t\t\t<a class=\"button button--medium apply-now__button js-submit__generic-form\" href=\"javascript:void(0);\" target=\"\" data-modal=\"\" data-id=\"\" data-text=\"\">\n\t\t\t\t\t" + this.inputFormButton.value + "\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>");
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(content));
        this.containerPreview.appendChild(docfragment);
        var docfragmentModal = document.createDocumentFragment();
        docfragmentModal.appendChild(document.createRange().createContextualFragment(content));
        this.containerPreviewModal.appendChild(docfragmentModal);
        var contentMain = "<div class=\"form-item-generic-form\" data-component=\"form-item-generic-form\">\n\t\t\t<form class=\"form\" data-frmcontainer=\"" + this.inputFormAnalytics.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"recipient\" value=\"" + this.inputFormRecipient.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"email\" value=\"" + this.inputFormEmail.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"subject\" value=\"" + this.inputFormSubject.value + "\">\n\t\t\t\t<input type=\"hidden\" name=\"redirect\" value=\"\">\n\t\t\t\t<div class=\"form__loader--container\">\n\t\t\t\t\t<img class=\"search__results-busy\" src=\"/file_source/assets/img/spinner.gif\" />\n\t\t\t\t</div>\n\t\t\t\t<div class=\"form__fields--container\">\n\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t" + content + "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"form__thankyou--container js-apply-now-success-message\">\n\t\t\t\t\t<h4 class=\"title title--module-sub-title text-center enquiry__title\">Thank you for your feedback</h4>\n\t\t\t\t\t<div class=\"form__success--image\">\n\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"form-complete\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\"\n\t\t\t\t\t\t\tclass=\"icon \">\n\t\t\t\t\t\t\t<!--?xml version=\"1.0\" encoding=\"UTF-8\"?--><svg xmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t\t\t\txmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"127px\" height=\"118px\" viewBox=\"0 0 127 118\" version=\"1.1\">\n\t\t\t\t\t\t\t\t<title>Group 4</title>\n\t\t\t\t\t\t\t\t<g id=\"Success-Messages\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t\t\t<g id=\"Success-message-\" transform=\"translate(-686.000000, -882.000000)\">\n\t\t\t\t\t\t\t\t\t\t<g id=\"Group-4\" transform=\"translate(687.000000, 883.000000)\">\n\t\t\t\t\t\t\t\t\t\t\t<g id=\"Group\">\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M106.4448,38.5349293 L106.4448,89.4262698 C106.4448,96.1257337 100.549937,101.6064 93.3440832,101.6064 L13.1007168,101.6064 C5.89617554,101.6064 0,96.1257337 0,89.4262698 L0,38.5349293 C0,37.5842148 0.160100916,36.6335004 0.478990445,35.7311716 C0.585286955,35.39901 0.691583465,35.1139265 0.851684381,34.8275352 C0.957980891,34.5424516 1.11808181,34.3057538 1.27687042,34.0206702 C3.08784799,31.0743707 6.59956973,29.0304 10.6440863,29.0304 L95.8007137,29.0304 C99.8452303,29.0304 103.358264,31.0743707 105.16793,34.0206702 C105.326718,34.3057538 105.486819,34.5424516 105.593116,34.8275352 C105.753217,35.1139265 105.859513,35.39901 105.96581,35.7311716 C106.284699,36.6335004 106.4448,37.5842148 106.4448,38.5349293\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-5\" fill=\"#C4E4FF\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M106.4448,38.5349293 L106.4448,89.4262698 C106.4448,96.1257337 100.549937,101.6064 93.3440832,101.6064 L13.1007168,101.6064 C5.89617554,101.6064 0,96.1257337 0,89.4262698 L0,38.5349293 C0,37.5842148 0.160100916,36.6335004 0.478990445,35.7311716 C0.585286955,35.39901 0.691583465,35.1139265 0.851684381,34.8275352 C0.957980891,34.5424516 1.11808181,34.3057538 1.27687042,34.0206702 C3.08784799,31.0743707 6.59956973,29.0304 10.6440863,29.0304 L95.8007137,29.0304 C99.8452303,29.0304 103.358264,31.0743707 105.16793,34.0206702 C105.326718,34.3057538 105.486819,34.5424516 105.593116,34.8275352 C105.753217,35.1139265 105.859513,35.39901 105.96581,35.7311716 C106.284699,36.6335004 106.4448,37.5842148 106.4448,38.5349293 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-7\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linejoin=\"round\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M0,40.0640948 C0,36.7352797 1.49077574,33.3516528 4.52350703,31.0428721 L4.84239656,30.8289724 L45.658944,2.38030335 C50.2113217,-0.793434449 56.2334783,-0.793434449 60.785856,2.38030335 L101.601091,30.8289724 L101.921293,31.0428721 C104.954024,33.3516528 106.4448,36.7352797 106.4448,40.0640948 C106.4448,41.1376043 106.284699,42.2124506 105.96581,43.2324851 C105.859513,43.6081466 105.753217,43.9303331 105.593116,44.2525196 C105.486819,44.5747062 105.326718,44.8434177 105.16793,45.1656043 C103.356952,48.4944194 99.8452303,50.8032 95.8007137,50.8032 L10.6440863,50.8032 C6.59956973,50.8032 3.08653569,48.4944194 1.27687042,45.1656043 C1.11808181,44.8434177 0.957980891,44.5747062 0.851684381,44.2525196 C0.691583465,43.9303331 0.585286955,43.6081466 0.478990445,43.2324851 C0.160100916,42.2124506 0,41.1376043 0,40.0640948\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-9\" fill=\"#9DD2FF\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M0,40.0640948 C0,36.7352797 1.49077574,33.3516528 4.52350703,31.0428721 L4.84239656,30.8289724 L45.658944,2.38030335 C50.2113217,-0.793434449 56.2334783,-0.793434449 60.785856,2.38030335 L101.601091,30.8289724 L101.921293,31.0428721 C104.954024,33.3516528 106.4448,36.7352797 106.4448,40.0640948 C106.4448,41.1376043 106.284699,42.2124506 105.96581,43.2324851 C105.859513,43.6081466 105.753217,43.9303331 105.593116,44.2525196 C105.486819,44.5747062 105.326718,44.8434177 105.16793,45.1656043 C103.356952,48.4944194 99.8452303,50.8032 95.8007137,50.8032 L10.6440863,50.8032 C6.59956973,50.8032 3.08653569,48.4944194 1.27687042,45.1656043 C1.11808181,44.8434177 0.957980891,44.5747062 0.851684381,44.2525196 C0.691583465,43.9303331 0.585286955,43.6081466 0.478990445,43.2324851 C0.160100916,42.2124506 0,41.1376043 0,40.0640948 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-11\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linejoin=\"round\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M91.9296,50.8032 L91.9296,8.98629601 C91.9296,8.03092904 90.7188472,7.2576 89.223443,7.2576 L14.802157,7.2576 C13.3067528,7.2576 12.096,8.03092904 12.096,8.98629601 L12.096,50.8032 L91.9296,50.8032 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-13\" fill=\"#FFFFFF\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M91.9296,50.8032 L91.9296,8.98629601 C91.9296,8.03092904 90.7188472,7.2576 89.223443,7.2576 L14.802157,7.2576 C13.3067528,7.2576 12.096,8.03092904 12.096,8.98629601 L12.096,50.8032 L91.9296,50.8032 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-15\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linecap=\"round\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-17\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 19.3536 84.672 19.3536 84.672 16.9344 21.7728 16.9344\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-19\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 24.192 67.7376 24.192 67.7376 21.7728 21.7728 21.7728\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-20\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 36.288 84.672 36.288 84.672 33.8688 21.7728 33.8688\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t\t<polygon id=\"Fill-21\" fill=\"#C4E4FF\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"21.7728 43.5456 67.7376 43.5456 67.7376 41.1264 21.7728 41.1264\"></polygon>\n\t\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t\t\t<g id=\"Group-5-Copy\" transform=\"translate(67.200000, 58.800000)\">\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M57.257088,28.628544 C57.257088,44.43936 44.43936,57.257088 28.628544,57.257088 C12.817728,57.257088 5.72981662e-14,44.43936 5.72981662e-14,28.628544 C5.72981662e-14,12.817728 12.817728,5.72981662e-14 28.628544,5.72981662e-14 C44.43936,5.72981662e-14 57.257088,12.817728 57.257088,28.628544\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Fill-22\" fill=\"#4AA740\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\t\t\t\t\t\td=\"M57.257088,28.628544 C57.257088,44.43936 44.43936,57.257088 28.628544,57.257088 C12.817728,57.257088 5.72981662e-14,44.43936 5.72981662e-14,28.628544 C5.72981662e-14,12.817728 12.817728,5.72981662e-14 28.628544,5.72981662e-14 C44.43936,5.72981662e-14 57.257088,12.817728 57.257088,28.628544 Z\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tid=\"Stroke-23\" stroke=\"#0033AA\" stroke-width=\"1.344\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t<polyline id=\"Stroke-24\" stroke=\"#FFFFFF\" stroke-width=\"2.688\" stroke-linecap=\"round\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpoints=\"15.067584 30.1353024 24.108672 39.1763904 42.189504 18.0809664\"></polyline>\n\t\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t</i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>";
        if (this.inputFormHeading) {
            var objectForm = {
                type: 'form-name',
                value: this.inputFormHeading.value
            };
            this.generatedJSON.push(objectForm);
        }
        if (this.inputFormAnalytics) {
            var objectForm = {
                type: 'form-analytics',
                value: this.inputFormAnalytics.value
            };
            this.generatedJSON.push(objectForm);
        }
        if (this.inputFormRecipient) {
            var objectForm = {
                type: 'form-recipient',
                value: this.inputFormRecipient.value
            };
            this.generatedJSON.push(objectForm);
        }
        if (this.inputFormEmail) {
            var objectForm = {
                type: 'form-email',
                value: this.inputFormEmail.value
            };
            this.generatedJSON.push(objectForm);
        }
        if (this.inputFormSubject) {
            var objectForm = {
                type: 'form-subject',
                value: this.inputFormSubject.value
            };
            this.generatedJSON.push(objectForm);
        }
        var outputHTML = this.element.querySelector('.form-builder__output--html');
        contentMain += "<!-- " + JSON.stringify(this.generatedJSON) + " -->";
        outputHTML.value = contentMain;
        var outputJSON = this.element.querySelector('.form-builder__output--json');
        outputJSON.value = JSON.stringify(this.generatedJSON);
    };
    //////////////////////////////////////
    //////////////////////////////////////
    // EXTRAS
    //////////////////////////////////////
    //////////////////////////////////////
    FormBuilder.prototype.openCloseField = function (event) {
        var element = undefined;
        if (event.currentTarget) {
            element = event.currentTarget;
        }
        else {
            element = event.target;
        }
        var containerSettingsAll = Array.from(this.element.querySelectorAll('.form-builder__container--field__settings'));
        containerSettingsAll.map(function (container) {
            container.classList.remove('open');
        });
        var containerSettings = element.querySelector('.form-builder__container--field__settings');
        if (!containerSettings.classList.contains('open')) {
            containerSettings.classList.add('open');
        }
    };
    FormBuilder.prototype.openCloseFieldTitle = function (containerSettings) {
        var containerSettingsAll = Array.from(this.element.querySelectorAll('.form-builder__container--field__settings'));
        containerSettingsAll.map(function (container) {
            if (container.closest('.form-builder__container--field')) {
                var parent_1 = container.closest('.form-builder__container--field');
                var heading = parent_1.querySelector('.form-builder__container--field__title');
                heading.classList.remove('open');
            }
            container.classList.remove('open');
        });
        if (!containerSettings.classList.contains('open')) {
            var parent_2 = containerSettings.closest('.form-builder__container--field');
            var heading = parent_2.querySelector('.form-builder__container--field__title');
            heading.classList.add('open');
            containerSettings.classList.add('open');
        }
    };
    FormBuilder.prototype.buttonRemove = function (event, containerSelected) {
        if (containerSelected === void 0) { containerSelected = ''; }
        var element = undefined;
        if (event.currentTarget) {
            element = event.currentTarget;
        }
        else {
            element = event.target;
        }
        var container = containerSelected;
        if (!containerSelected) {
            container = element.closest('.js-generic-form-field');
        }
        this.containerFieldsComponents.removeChild(container);
        this.buildPreview();
    };
    FormBuilder.prototype.sortable = function () {
        var _this = this;
        var selectedField = undefined;
        this.containerFields = this.element.querySelectorAll('.form-builder__container--field');
        [].forEach.call(this.containerFields, function (field) {
            if (!_this.hasFocus) {
                field.setAttribute('draggable', 'true');
            }
            else {
                field.removeAttribute('draggable');
            }
            field.addEventListener('dragstart', function (e) {
                e.dataTransfer.effectAllowed = "move";
                e.dataTransfer.setData("text/plain", null); // Thanks to bqlou for their comment.
                var element = undefined;
                if (e.currentTarget) {
                    element = e.currentTarget;
                }
                else {
                    element = e.target;
                }
                e.dataTransfer.effectAllowed = "move";
                e.dataTransfer.setData("text/plain", null);
                selectedField = element;
            }, false);
            field.addEventListener('dragover', function (e) {
                var element = undefined;
                if (e.currentTarget) {
                    element = e.currentTarget;
                }
                else {
                    element = e.target;
                }
                if (_this.isBefore(selectedField, element)) {
                    element.parentNode.insertBefore(selectedField, element);
                }
                else {
                    element.parentNode.insertBefore(selectedField, element.nextSibling);
                }
            }, false);
            field.addEventListener('dragend', function (e) {
                selectedField = null;
                _this.buildPreview();
            }, false);
        });
    };
    FormBuilder.prototype.isBefore = function (el1, el2) {
        if (el2.parentNode === el1.parentNode) {
            for (var cur = el1.previousSibling; cur && cur.nodeType !== 9; cur = cur.previousSibling) {
                if (cur === el2) {
                    return true;
                }
            }
        }
        return false;
    };
    FormBuilder.prototype.inputFocus = function (field) {
        var _this = this;
        if (field === void 0) { field = ''; }
        if (field) {
            field.addEventListener('focus', function (e) {
                _this.hasFocus = true;
                _this.sortable();
            });
            field.addEventListener('focusout', function (e) {
                _this.hasFocus = false;
                _this.sortable();
            });
        }
    };
    FormBuilder.prototype.camelCase = function (label) {
        if (label === void 0) { label = ''; }
        return label.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '');
    };
    return FormBuilder;
}(Base));
export { FormBuilder };



//////////////////
// WEBPACK FOOTER
// ./components/form-builder/form-builder.component.ts
// module id = 299
// module chunks = 0